import {
    ligainicial
} from "./rutainicial"

const ligabase = ligainicial + "2025/Lic/C"

export const licitaciones2025 = [
    {
        // CONVOCATORIA NUM# 075
        'numConvocatoria' : 'Convocatoria No. 075/2025.',
        'idConvocatoria' : 'Convocatoria75',
        'procedimientos' : [
            // Licitación N333
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N333-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 16 de diciembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de la nueva Estación de Bomberos, José María Morelos y Pavón en el Municipio de Pachuca de Soto, Estado de Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (segundo procedimiento)',
                'urlAnexos' : `${ ligabase }75/N333/N333.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }75/N333/JAN333.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }75/N333/APN333.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }75/N333/FAN333.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 074
        'numConvocatoria' : 'Convocatoria No. 074/2025.',
        'idConvocatoria' : 'Convocatoria74',
        'procedimientos' : [
            // Licitación N332
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N332-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 5 al 11 de diciembre de 2025',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto asfaltico circuito de la colonia La Ranchería, en el municipio de Progreso de Obregón.; ubicada en la localidad de La Ranchería, Municipio de Progreso de Obregón, Estado de Hidalgo. (segundo procedimiento)',
                'urlAnexos' : `${ ligabase }74/N332/N332.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }74/N332/JAN332.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }74/N332/APN332.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }74/N332/FAN332.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }74/N332/AMDFAN332.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 073
        'numConvocatoria' : 'Convocatoria No. 073/2025.',
        'idConvocatoria' : 'Convocatoria73',
        'procedimientos' : [
            // Licitación N331
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N331-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025',
                'descripcionProcedimiento' : 'Pavimentación de concreto Hidráulico en camino rural La Gargantilla - Tripuente, en el municipio de Pisaflores; ubicada en Varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N331/N331.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N331/JAN331.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }73/N331/AMDJAN331.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N331/APN331.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N331/FAN331.pdf`,
                       },
                ],
            },
            // Licitación N330
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N330-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de camino de concreto hidráulico tramo entronque carretera (Huautla - Chalingo) - Vinasco, en el municipio de Huautla.; ubicada en la localidad de Vinasco, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N330/N330.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N330/JAN330.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N330/APN330.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N330/FAN330.pdf`,
                       },
                ],
            },
            // Licitación N329
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N329-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto asfáltico en Avenida Petroleros, en el municipio de Mineral de la Reforma.; ubicada en la localidad de pachuquilla, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }73/N329/N329.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N329/JAN329.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N329/APN329.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N329/FAN329.pdf`,
                       },
                ],
            },
            // Licitación N328
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N328-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Tecnificación parcelaria con multicompuertas en el módulo de riego Asociación de Usuario del Distrito de Riego 027 Ixmiquilpan A.C., en la localidad de El Mandho, municipio de Ixmiquilpan, Hidalgo.; de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }73/N328/N328.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N328/JAN328.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N328/APN328.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N328/FAN328.pdf`,
                       },
                ],
            },
            // Licitación N327
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N327-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación del sistema de agua potable en manantial "El Ushi", en la localidad de La Palma, en el municipio de Jacala de Ledezma; ubicada en la localidad de La Palma, Municipio de Jacala de Ledezma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }73/N327/N327.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N327/JAN327.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N327/APN327.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N327/FAN327.pdf`,
                       },
                ],
            },
            // Licitación N326
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N326-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de sistema de agua entubada en la localidad de El Olivo, municipio de Ixmiquilpan.; ubicada en la localidad de El Olivo, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N326/N326.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N326/JAN326.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N326/APN326.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N326/FAN326.pdf`,
                       },
                ],
            },
            // Licitación N325
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N325-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de red de drenaje sanitario y planta de tratamiento de aguas residuales en la comunidad de La Estancia, municipio de Chilcuautla.; ubicada en la localidad de La Estancia, Municipio de Chilcuautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }73/N325/N325.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N325/JAN325.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N325/APN325.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N325/FAN325.pdf`,
                       },
                ],
            },
            // Licitación N324
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N324-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de calle Sin Nombre en tramo Encino Largo - Cerro Prieto, en Encino Largo, municipio de La Misión; ubicada en la localidad de Encino Largo, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N324/N324.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N324/JAN324.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N324/APN324.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N324/FAN324.pdf`,
                       },
                ],
            },
            // Licitación N323
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N323-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en camino rural Santa María - San Nicolás, en el municipio de Juárez Hidalgo.; ubicada en la localidad de San Nicolás Coatzontla, Municipio de Juárez Hidalgo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N323/N323.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N323/JAN323.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N323/APN323.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N323/FAN323.pdf`,
                       },
                ],
            },
            // Licitación N322
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N322-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Hidráulica La Misión - Puerto de Naranjos, subtramo La Misión - Loma de Pericón, en el municipio de La Misión; ubicada en la localidad de Puerto de Naranjos, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N322/N322.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N322/JAN322.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N322/APN322.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N322/FAN322.pdf`,
                       },
                ],
            },
            // Licitación N321
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N321-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación asfáltica a Jardín de las Flores, en la localidad de Pueblo Nuevo, en el municipio de Ixmiquilpan.; ubicada en la localidad de Pueblo Nuevo, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N321/N321.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N321/JAN321.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N321/APN321.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N321/FAN321.pdf`,
                       },
                ],
            },
            // Licitación N320
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N320-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Terminación de Puente Vado "Tres Cruces" sobre Río Venados (Río Grande) en el municipio de Metztitlán.; ubicada en la localidad de Tres Cruces, Municipio de Metztitlán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N320/N320.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N320/JAN320.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N320/APN320.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N320/FAN320.pdf`,
                       },
                ],
            },
            // Licitación N319
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N319-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la avenida Juárez en la localidad de Acayuca, municipio de Zapotlán de Juárez; ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N319/N319.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N319/JAN319.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N319/APN319.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N319/FAN319.pdf`,
                       },
                ],
            },
            // Licitación N318
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N318-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en el tramo: Coatlamayan - Acatepec, del Km. 0+000 al Km. 1+884, subtramo: del Km. 0+000 al Km. 1+000. en la localidad de Acatepec, municipio de Xochicoatlán.; ubicada en la localidad de Acatepec, Municipio de Xochicoatlán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N318/N318.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N318/JAN318.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N318/APN318.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N318/FAN318.pdf`,
                       },
                ],
            },
            // Licitación N317
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N317-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 10 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Trabajos complementarios de pavimentación de concreto hidráulico en la calle de acceso a Rancho La Colonia, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }73/N317/N317.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }73/N317/JAN317.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }73/N317/APN317.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }73/N317/FAN317.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 072
        'numConvocatoria' : 'Convocatoria No. 072/2025.',
        'idConvocatoria' : 'Convocatoria72',
        'procedimientos' : [
            // Licitación N316
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N316-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de diciembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de calle "1" del Complejo Industrial Sahagún; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }72/N316/N316.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }72/N316/JAN316.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }72/N316/APN316.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }72/N316/FAN316.pdf`,
                       },
                ],
            },
            // Licitación N315
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N315-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Repavimentación de Avenidas de las Fracciones "3A" y "1B" del Complejo Industrial Sahagún; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }72/N315/N315.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }72/N315/JAN315.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }72/N315/APN315.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }72/N315/FAN315.pdf`,
                       },
                ],
            },
            // Licitación N314
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N314-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de caminos afectados en el municipio de Tlanchinol.; ubicada en Varias localidades del Municipio de Tlanchinol, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }72/N314/N314.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }72/N314/JAN314.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }72/N314/APN314.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }72/N314/FAN314.pdf`,
                       },
                ],
            },
            // Licitación N313
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N313-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de instalaciones eléctricas y sanitarias para el servicio del Centro Regional de Hacienda Metropolitano de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }72/N313/N313.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }72/N313/JAN313.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }72/N313/APN313.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }72/N313/FAN313.pdf`,
                       },
                ],
            },
            // Licitación N312
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N312-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 8 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de Tanque público de agua potable y Sistema de agua entubada de Santiago a San Bartolo Tutotepec, en el municipio de San Bartolo Tutotepec.; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }72/N312/N312.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }72/N312/JAN312.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }72/N312/APN312.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }72/N312/FAN312.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 071
        'numConvocatoria' : 'Convocatoria No. 071/2025.',
        'idConvocatoria' : 'Convocatoria71',
        'procedimientos' : [
            // Licitación N311
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N311-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 5 de diciembre de 2025',
                'descripcionProcedimiento' : 'Proyecto de rehabilitación de 4 colectores (Toyota, Encinos, Providencia y Forjadores), Parque fotovoltaico, estudio tarifario, modelación de diferentes colectores incluyendo el emisor México y PTAR Pachuca, en Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (segundo procedimiento)',
                'urlAnexos' : `${ ligabase }71/N311/N311.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }71/N311/JAN311.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }71/N311/APN311.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }71/N311/FAN311.pdf`,
                       },
                ],
            },
            // Licitación N310
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N310-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 5 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción con concreto hidráulico de la calle Heroico Colegio Naval, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (segundo procedimiento)',
                'urlAnexos' : `${ ligabase }71/N310/N310.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }71/N310/JAN310.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }71/N310/APN310.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }71/N310/FAN310.pdf`,
                       },
                ],
            },
            // Licitación N309
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N309-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 5 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. San Bartolo - San Miguel (segunda etapa), municipio de San Bartolo Tutotepec.; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }71/N309/N309.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }71/N309/JAN309.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }71/N309/APN309.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }71/N309/FAN309.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }71/N309/AMDFAN309.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 070
        'numConvocatoria' : 'Convocatoria No. 070/2025.',
        'idConvocatoria' : 'Convocatoria70',
        'procedimientos' : [
            // Licitación N308
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N308-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025',
                'descripcionProcedimiento' : 'Construcción de Velarias y Espacios de Resguardo en las Instalaciones del Parque Cultural Hidalguense; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }70/N308/N308.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }70/N308/JAN308.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }70/N308/AMDJAN308.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }70/N308/APN308.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }70/N308/FAN308.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }70/N308/AMDFAN308.pdf`,
                    },
                ],
            },
            // Licitación N307
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N307-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la nueva Estación de Bomberos, José María Morelos y Pavón en el Municipio de Pachuca de Soto, Estado de Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }70/N307/N307.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }70/N307/JAN307.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }70/N307/APN307.pdf`,
                       },
                       // {
                       //     'resultado' : 'Fallo',
                       //     'urlresultado' : `${ ligabase }70/N307/FAN307.pdf`,
                       // },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 069
        'numConvocatoria' : 'Convocatoria No. 069/2025.',
        'idConvocatoria' : 'Convocatoria69',
        'procedimientos' : [
            // Licitación N306
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N306-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Calnali - San Andrés - Santa Lucía, segunda etapa, en el municipio de Calnali.; ubicada en la localidad de Santa Lucía (Mesa de Santa Lucía), Municipio de Calnali, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }69/N306/N306.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }69/N306/JAN306.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }69/N306/APN306.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }69/N306/FAN306.pdf`,
                       },
                ],
            },
            // Licitación N305
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N305-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle 12 de octubre, Nopancalco, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }69/N305/N305.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }69/N305/JAN305.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }69/N305/APN305.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }69/N305/FAN305.pdf`,
                       },
                ],
            },
            // Licitación N304
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N304-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico y muro de contención, en calle Sin Nombre, en la localidad de Tepemaxac 1, 2, 3., municipio de Huejutla de Reyes.; ubicada en la localidad de Tepemaxac, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }69/N304/N304.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }69/N304/JAN304.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }69/N304/APN304.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }69/N304/FAN304.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }69/N304/AMDFAN304.pdf`,
                    },
                ],
            },
            // Licitación N303
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N303-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de drenaje sanitario en vialidad San Ángel (primera etapa), en el municipio de Mineral de la Reforma; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }69/N303/N303.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }69/N303/JAN303.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }69/N303/APN303.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }69/N303/FAN303.pdf`,
                       },
                ],
            },
            // Licitación N302
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N302-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en avenida constituyentes, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }69/N302/N302.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }69/N302/JAN302.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }69/N302/APN302.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }69/N302/FAN302.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 068
        'numConvocatoria' : 'Convocatoria No. 068/2025.',
        'idConvocatoria' : 'Convocatoria68',
        'procedimientos' : [
            // Licitación N301
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N301-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación integral y construcción de 1er. nivel Centro de Asistencia Social Casa Cuna, en Pachuca de Soto Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }68/N301/N301.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }68/N301/JAN301.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }68/N301/APN301.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }68/N301/FAN301.pdf`,
                       },
                ],
            },
            // Licitación N300
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N300-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de oficinas centrales de la Secretarían de Contraloría (segunda etapa); ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }68/N300/N300.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }68/N300/JAN300.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }68/N300/APN300.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }68/N300/FAN300.pdf`,
                       },
                ],
            },
            // Licitación N299
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N299-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de techumbre en la localidad Cerro Colorado en Atotonilco el Grande.; ubicada en la localidad de Cerro Colorado, Municipio de Atotonilco el Grande, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }68/N299/N299.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }68/N299/JAN299.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }68/N299/APN299.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }68/N299/FAN299.pdf`,
                       },
                ],
            },
            // Licitación N298
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N298-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Calnali - Papatlatla, segunda etapa, en el municipio de Calnali.; ubicada en la localidad de Papatlatla, Municipio de Calnali, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }68/N298/N298.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }68/N298/JAN298.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }68/N298/APN298.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }68/N298/FAN298.pdf`,
                       },
                ],
            },
            // Licitación N297
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N297-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de noviembre al 2 de diciembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico Boulevard Everardo Márquez del km 5+280 al 5+830 de Boulevard Javier Rojo  Gómez - Río de las Avenidas (dos cuerpos), en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (Segundo Procedimiento).',
                'urlAnexos' : `${ ligabase }68/N297/N297.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }68/N297/JAN297.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }68/N297/APN297.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }68/N297/FAN297.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 067
        'numConvocatoria' : 'Convocatoria No. 067/2025.',
        'idConvocatoria' : 'Convocatoria67',
        'procedimientos' : [
            // Licitación N296
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N296-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 26 de noviembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de línea de distribución en calle Corregidora de Tercera Demarcación, en el municipio de Francisco I. Madero; ubicada en la localidad de Tepatepec, Municipio de Francisco I. Madero, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }67/N296/N296.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }67/N296/JAN296.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }67/N296/APN296.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }67/N296/FAN296.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }67/N296/AMDFAN296.pdf`,
                    },
                ],
            },
            // Licitación N295
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N295-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 26 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de cancha de usos múltiples y construcción de techumbre, en la localidad de San Antonio Tlaxco, en el municipio de Meztitlán.; ubicada en la localidad de San Antonio Tlaxco, Municipio de Metztitlán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }67/N295/N295.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }67/N295/JAN295.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }67/N295/APN295.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }67/N295/FAN295.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 066
        'numConvocatoria' : 'Convocatoria No. 066/2025.',
        'idConvocatoria' : 'Convocatoria66',
        'procedimientos' : [
            // Licitación N294
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N294-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025',
                'descripcionProcedimiento' : 'Construcción de unidad administrativa de innovación gubernamental en Pachuca de Soto, Hidalgo.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N294/N294.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N294/JAN294.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N294/APN294.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N294/FAN294.pdf`,
                       },
                ],
            },
            // Licitación N293
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N293-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Carretera Federal Pachuca - Huejutla km 118+000 al km 144+450, en los municipios de Lolotla y Molango de Escamilla.; de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }66/N293/N293.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N293/JAN293.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N293/APN293.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N293/FAN293.pdf`,
                       },
                ],
            },
            // Licitación N292
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N292-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en camino rural de la localidad de Humotitla Candelaria, municipio de Huejutla de Reyes.; ubicada en la localidad de Humotitla Candelaría, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N292/N292.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N292/JAN292.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N292/APN292.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N292/FAN292.pdf`,
                       },
                ],
            },
            // Licitación N291
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N291-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica del C.R.Texcatla - Chapulhuacanito, en el municipio de San Felipe Orizatlán.; de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }66/N291/N291.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N291/JAN291.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N291/APN291.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N291/FAN291.pdf`,
                       },
                ],
            },
            // Licitación N290
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N290-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en calle sin nombre, colonia Lomas de Chapultepec, municipio de Huejutla de Reyes.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N290/N290.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N290/JAN290.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N290/APN290.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N290/FAN290.pdf`,
                       },
                ],
            },
            // Licitación N289
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N289-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la unidad deportiva El Charquito en la localidad de Acayuca en el municipio de Zapotlán de Juárez; ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N289/N289.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N289/JAN289.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }66/N289/AMDJAN289.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N289/APN289.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N289/FAN289.pdf`,
                       },
                ],
            },
            // Licitación N288
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N288-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de muro de contención y alcantarilla sobre carretera Pacula - El Puerto, en la localidad de Jiliapan, municipio de Pacula.; ubicada en la localidad de Jiliapan, Municipio de Pacula, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N288/N288.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N288/JAN288.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N288/APN288.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N288/FAN288.pdf`,
                       },
                ],
            },
            // Licitación N287
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N287-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación y mejoramiento de imagen urbana sobre tramo carretero desde el crucero al libramiento en col. La Loma hacia la col. Centro, en el municipio de Huasca de Ocampo.; ubicada en Varias localidades del Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }66/N287/N287.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N287/JAN287.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N287/APN287.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N287/FAN287.pdf`,
                       },
                ],
            },
            // Licitación N286
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N286-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de puente vehicular en la localidad de Boxtha Chico, en el municipio de San Salvador; ubicada en la localidad de Bóxtha Chico, Municipio de San Salvador, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N286/N286.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N286/JAN286.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N286/APN286.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N286/FAN286.pdf`,
                       },
                ],
            },
            // Licitación N285
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N285-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de la calle del campo de fútbol en la comunidad de Jalapa, en el municipio de Zacualtipán de Angeles.; ubicada en la localidad de Jalapa, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N285/N285.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N285/JAN285.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N285/APN285.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N285/FAN285.pdf`,
                       },
                ],
            },
            // Licitación N284
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N284-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Pino, en la col. La Palma, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N284/N284.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N284/JAN284.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N284/APN284.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N284/FAN284.pdf`,
                       },
                ],
            },
            // Licitación N283
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N283-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Desierto de Los Leones, en el municipio de Tetepango.; ubicada en la localidad y Municipio de Tetepango, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N283/N283.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N283/JAN283.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N283/APN283.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N283/FAN283.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }66/N283/AMDFAN283.pdf`,
                    },
                ],
            },
            // Licitación N282
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N282-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación asfáltica de Av. Atlán, en San José Atlán, en el municipio de Huichapan; ubicada en la localidad de San José Atlán, Municipio de Huichapan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }66/N282/N282.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N282/JAN282.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N282/APN282.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N282/FAN282.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }66/N282/AMDFAN282.pdf`,
                    },
                ],
            },
            // Licitación N281
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N281-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico del Camino Acatipa - Texoloc, en el Municipio de Xochiatipan; ubicada en la localidad de Acatipa, Municipio de Xochiatipan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N281/N281.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N281/JAN281.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N281/APN281.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N281/FAN281.pdf`,
                       },
                ],
            },
            // Licitación N280
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N280-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de concreto hidráulico de Boulevard de Acceso Principal en Avenida Júarez del km. 0+000 al km. 0+420 en el municipio de Singuilucan.; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }66/N280/N280.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N280/JAN280.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N280/APN280.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N280/FAN280.pdf`,
                       },
                ],
            },
            // Licitación N279
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N279-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación con pavimento hidráulico del camino entronque Xochiatipan a Nuevo Coyolar - Chiapa - Pohuantitla - Pachiquitla en el municipio de Xochiatipan; ubicada en la localidad de Chiapa, Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }66/N279/N279.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N279/JAN279.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N279/APN279.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N279/FAN279.pdf`,
                       },
                ],
            },
            // Licitación N278
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N278-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 25 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Sustitución de acueducto de concreto armado de 18 pulgadas de diámetro en el municipio de Francisco I. Madero; ubicada en Varias localidades del Municipio de Francisco I. Madero, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }66/N278/N278.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }66/N278/JAN278.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }66/N278/APN278.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }66/N278/FAN278.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 065
        'numConvocatoria' : 'Convocatoria No. 065/2025.',
        'idConvocatoria' : 'Convocatoria65',
        'procedimientos' : [
            // Licitación N277
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N277-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de noviembre de 2025',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto asfaltico circuito de la colonia La Ranchería, en el municipio de Progreso de Obregón.; ubicada en la localidad de La Ranchería, Municipio de Progreso de Obregón, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }65/N277/N277.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }65/N277/JAN277.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }65/N277/APN277.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }65/N277/FAN277.pdf`,
                       },
                ],
            },
            // Licitación N276
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N276-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de Planta de Tratamiento de Aguas Residuales en la localidad de Chiconcoac, en el municipio de Lolotla.; ubicada en la localidad de Chiconcoac, Municipio de Lolotla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }65/N276/N276.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }65/N276/JAN276.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }65/N276/APN276.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }65/N276/FAN276.pdf`,
                       },
                ],
            },
            // Licitación N275
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N275-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de muro de contención y pavimentación con concreto hidráulico calle sin nombre, en la localidad de Cuatecomaco, en el municipio de Jaltocán.; ubicada en la localidad de Cuatecomaco, Municipio de Jaltocán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }65/N275/N275.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }65/N275/JAN275.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }65/N275/APN275.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }65/N275/FAN275.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }65/N275/AMDFAN275.pdf`,
                    },
                ],
            },
            // Licitación N274
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N274-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de carretera del tramo libramiento de Metztitlan.; ubicada en la localidad y Municipio de Metztitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }65/N274/N274.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }65/N274/JAN274.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }65/N274/APN274.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }65/N274/FAN274.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 064
        'numConvocatoria' : 'Convocatoria No. 064/2025.',
        'idConvocatoria' : 'Convocatoria64',
        'procedimientos' : [
            // Licitación N273
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N273-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 19 de noviembre de 2025',
                'descripcionProcedimiento' : 'Adecuación vial en el distribuidor Miguel Hidalgo (glorieta 24 horas); ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }64/N273/N273.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }64/N273/JAN273.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }64/N273/APN273.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }64/N273/FAN273.pdf`,
                       },
                ],
            },
            // Licitación N272
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N272-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 19 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de dos puentes colgantes sobre el río Amajac en las localidades de Vado Hondo y San Andresito ubicados en los límites de los municipios de Jacala de Ledezma y Tlahuiltepa; ubicada en Varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }64/N272/N272.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }64/N272/JAN272.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }64/N272/APN272.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }64/N272/FAN272.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 063
        'numConvocatoria' : 'Convocatoria No. 063/2025.',
        'idConvocatoria' : 'Convocatoria63',
        'procedimientos' : [
            // Licitación N271
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N271-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de Áreas Administrativas y de atención a la Ciudadanía en Pachuca de Soto, Hidalgo.; de Cobertura Estatal',
                'urlAnexos' : `${ ligabase }63/N271/N271.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }63/N271/JAN271.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }63/N271/APN271.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }63/N271/FAN271.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 062
        'numConvocatoria' : 'Convocatoria No. 062/2025.',
        'idConvocatoria' : 'Convocatoria62',
        'procedimientos' : [
            // Licitación N270
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N270-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025',
                'descripcionProcedimiento' : 'Proyecto de rehabilitación de 4 colectores (Toyota, Encinos, Providencia y Forjadores), Parque fotovoltaico, estudio tarifario, modelación de diferentes colectores incluyendo el emisor México y PTAR Pachuca, en Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }62/N270/N270.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N270/JAN270.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N270/APN270.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }62/N270/FAN270.pdf`,
                    //    },
                ],
            },
            // Licitación N269
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N269-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento asfáltico en la calle Emiliano Zapata en la localidad de Demacu, en el municipio de San Salvador; ubicada en la localidad de Demacu, Municipio de San Salvador, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N269/N269.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N269/JAN269.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N269/APN269.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N269/FAN269.pdf`,
                       },
                ],
            },
            // Licitación N268
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N268-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación carretera Los Martínez a El Durazno, en el municipio de Ixmiquilpan.; ubicada en la localidad de Barrio los Martínez, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }62/N268/N268.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N268/JAN268.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N268/APN268.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N268/FAN268.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }62/N268/AMDFAN268.pdf`,
                    },
                ],
            },
            // Licitación N267
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N267-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación asfáltica en la comunidad de San Bartolo Ozocalpan, en el municipio de Chapantongo.; ubicada en la localidad de San Bartolo Ozocalpan, Municipio de Chapantongo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }62/N267/N267.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N267/JAN267.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N267/APN267.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N267/FAN267.pdf`,
                       },
                ],
            },
            // Licitación N266
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N266-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en calles Vicente Guerrero, cda. Hidalgo, Anacleto Ramos, de la col. Charco Azul, municipio de Huejutla de Reyes.; ubicada en la localidad de Charco Azul, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N266/N266.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N266/JAN266.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N266/APN266.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N266/FAN266.pdf`,
                       },
                ],
            },
            // Licitación N265
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N265-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en varias calles, en la localidad de Palzoquico, municipio de Huejutla de Reyes.; ubicada en la localidad de Palzoquico, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N265/N265.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N265/JAN265.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N265/APN265.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N265/FAN265.pdf`,
                       },
                ],
            },
            // Licitación N264
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N264-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de pavimento hidráulico, camino Hacienda La Concepción - salida La Estanzuela, varios tramos, col. Tilcuautla, municipio de San Agustín Tlaxiaca.; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N264/N264.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N264/JAN264.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N264/APN264.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N264/FAN264.pdf`,
                       },
                ],
            },
            // Licitación N263
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N263-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en la localidad de Ahuatitla, en el municipio de Huautla.; ubicada en la localidad de Ahuatitla, Municipio de Huautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N263/N263.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N263/JAN263.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N263/APN263.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N263/FAN263.pdf`,
                       },
                ],
            },
            // Licitación N262
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N262-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Adecuación de la zona de hospitales en boulevard Pachuca - Pachuquilla, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N262/N262.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N262/JAN262.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N262/APN262.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N262/FAN262.pdf`,
                       },
                ],
            },
            // Licitación N261
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N261-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica del acceso a la escuela normal superior, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N261/N261.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N261/JAN261.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N261/APN261.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N261/FAN261.pdf`,
                       },
                ],
            },
            // Licitación N260
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N260-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción con concreto hidráulico de la calle Heroico Colegio Naval, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }62/N260/N260.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N260/JAN260.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N260/APN260.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }62/N260/FAN260.pdf`,
                    //    },
                ],
            },
            // Licitación N259
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N259-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de la entrada principal de la comunidad de Sietla, en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Sietla, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N259/N259.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N259/JAN259.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N259/APN259.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N259/FAN259.pdf`,
                       },
                ],
            },
            // Licitación N258
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N258-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de la calle entrada principal de la comunidad de Tehuitzila, en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Tehuitzila, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N258/N258.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N258/JAN258.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N258/APN258.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N258/FAN258.pdf`,
                       },
                ],
            },
            // Licitación N257
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N257-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 18 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de la calle principal de la comunidad de Coatlila, en el municipio de Zacualtipán de Ángeles.; ubicada en la localidad de Coatlila, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }62/N257/N257.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }62/N257/JAN257.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }62/N257/APN257.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }62/N257/FAN257.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 061
        'numConvocatoria' : 'Convocatoria No. 061/2025.',
        'idConvocatoria' : 'Convocatoria61',
        'procedimientos' : [
            // Licitación N256
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N256-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025',
                'descripcionProcedimiento' : 'Terminación de la construcción de las Nuevas Oficinas de Gobierno en Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }61/N256/N256.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N256/JAN256.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N256/APN256.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N256/FAN256.pdf`,
                       },
                ],
            },
            // Licitación N255
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N255-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico Cerro Colorado, municipio de Atotonilco el Grande, Hgo.; ubicada en la localidad de Cerro Colorado, Municipio de Atotonilco el Grande, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }61/N255/N255.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N255/JAN255.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N255/APN255.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N255/FAN255.pdf`,
                       },
                ],
            },
            // Licitación N254
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N254-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de camino hacia bienes comunales en la localidad de El Paredón, en el municipio de Eloxochitlan.; ubicada en la localidad de La Laguna Seca (Paredón), Municipio de Eloxochitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }61/N254/N254.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N254/JAN254.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N254/APN254.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N254/FAN254.pdf`,
                       },
                ],
            },
            // Licitación N253
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N253-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de camino en la localidad de Tostlamantla, en el municipio de Calnali.; ubicada en la localidad de Tostlamantla, Municipio de Calnali, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }61/N253/N253.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N253/JAN253.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N253/APN253.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N253/FAN253.pdf`,
                       },
                ],
            },
            // Licitación N252
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N252-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle 1ro. de Villa y Gómez Farias en la Col. Centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }61/N252/N252.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N252/JAN252.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N252/APN252.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N252/FAN252.pdf`,
                       },
                ],
            },
            // Licitación N251
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N251-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la C.E. Metepec - Tortugas Acocul, en el municipio de Metepec.; ubicada en la localidad de Tortugas, Municipio de Metepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }61/N251/N251.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N251/JAN251.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N251/APN251.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N251/FAN251.pdf`,
                       },
                ],
            },
            // Licitación N250
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N250-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 11 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico y rehabilitación de línea de agua potable en calle Emilio Hernández, en el municipio de Actopan.; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }61/N250/N250.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }61/N250/JAN250.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }61/N250/APN250.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }61/N250/FAN250.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 060
        'numConvocatoria' : 'Convocatoria No. 060/2025.',
        'idConvocatoria' : 'Convocatoria60',
        'procedimientos' : [
            // Licitación N249
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N249-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Edificación de oficinas administrativas de la Policía Industrial Bancaria del Estado de Hidalgo; de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }60/N249/N249.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }60/N249/JAN249.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }60/N249/APN249.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }60/N249/FAN249.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 059
        'numConvocatoria' : 'Convocatoria No. 059/2025.',
        'idConvocatoria' : 'Convocatoria59',
        'procedimientos' : [
            // Licitación N248
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N248-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de pavimento hidráulico, banquetas, guarniciones, alumbrado público, agua potable, drenaje sanitario en la calle Heroico Colegio Militar, colonia Centro, en el municipio de Tula de Allende.; ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }59/N248/N248.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }59/N248/JAN248.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }59/N248/APN248.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }59/N248/FAN248.pdf`,
                    //    },
                ],
            },
            // Licitación N247
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N247-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica en la carretera Ciudad Sahagún - Emiliano Zapata, en el municipio de  Tepeapulco.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }59/N247/N247.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }59/N247/JAN247.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }59/N247/APN247.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }59/N247/FAN247.pdf`,
                       },
                ],
            },
            // Licitación N246
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N246-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción con pavimento hidráulico en la Av. Tezontle, en la Col. Venta Prieta, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }59/N246/N246.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }59/N246/JAN246.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }59/N246/APN246.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }59/N246/FAN246.pdf`,
                       },
                ],
            },
            // Licitación N245
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N245-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Coatzacoalcos, en el Puerto Lázaro Cárdenas, en el municipio de San Salvador.; ubicada en la localidad de El Puerto Lázaro Cárdenas, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }59/N245/N245.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }59/N245/JAN245.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }59/N245/APN245.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }59/N245/FAN245.pdf`,
                       },
                ],
            },
            // Licitación N244
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N244-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle de acceso a la localidad nuevo porvenir, en el municipio de Chapulhuacán.; ubicada en la localidad de Nuevo Porvenir (Colonia), Municipio de Chapulhuacán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }59/N244/N244.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }59/N244/JAN244.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }59/N244/APN244.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }59/N244/FAN244.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 058
        'numConvocatoria' : 'Convocatoria No. 058/2025.',
        'idConvocatoria' : 'Convocatoria58',
        'procedimientos' : [
            // Licitación N243
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N243-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Mantenimiento de Teatro Hidalgo Bartolomé de Medina; de Cobertura Estatal',
                'urlAnexos' : `${ ligabase }58/N243/N243.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }58/N243/JAN243.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }58/N243/APN243.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }58/N243/FAN243.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 057
        'numConvocatoria' : 'Convocatoria No. 057/2025.',
        'idConvocatoria' : 'Convocatoria57',
        'procedimientos' : [
            // Licitación N242
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N242-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico Boulevard Everardo Márquez del km 5+280 al 5+830 de Boulevard Javier Rojo  Gómez - Río de las Avenidas (dos cuerpos), en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }57/N242/N242.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }57/N242/JAN242.pdf`,
                       },
                       {
                            'resultado' : 'Anexo modificatorio',
                            'urlresultado' : `${ ligabase }57/N242/AMDJAN242.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }57/N242/APN242.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }57/N242/FAN242.pdf`,
                    //    },
                ],
            },
            // Licitación N241
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N241-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de tanque de almacenamiento para suministro de agua potable que beneficiará a la cabecera municipal y a las comunidades de Tlatempa y Tlacpac en el municipio de Acaxochitlán.; ubicada en la localidad de Tlacpac, Municipio de Acaxochitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }57/N241/N241.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }57/N241/JAN241.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }57/N241/APN241.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }57/N241/FAN241.pdf`,
                       },
                ],
            },
            // Licitación N240
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N240-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación asfáltica en Av. Serranos, en la localidad de Xuchitlán, en el municipio de San Salvador.; ubicada en la localidad de Xuchitlán, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }57/N240/N240.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }57/N240/JAN240.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }57/N240/APN240.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }57/N240/FAN240.pdf`,
                       },
                ],
            },
            // Licitación N239
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N239-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en calle Álamo, fraccionamiento El Saucillo, en el municipio de Mineral de la Reforma.; ubicada en la localidad de El Saucillo, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }57/N239/N239.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }57/N239/JAN239.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }57/N239/APN239.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }57/N239/FAN239.pdf`,
                       },
                ],
            },
            // Licitación N238
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N238-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de pavimento asfáltico de la calle Río Usumacinta, El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }57/N238/N238.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }57/N238/JAN238.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }57/N238/APN238.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }57/N238/FAN238.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 056
        'numConvocatoria' : 'Convocatoria No. 056/2025.',
        'idConvocatoria' : 'Convocatoria56',
        'procedimientos' : [
            // Licitación N237
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N237-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Construcción del Centro Pilares en las Colonias del Sur, ubicado en Pachuca de Soto Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }56/N237/N237.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }56/N237/JAN237.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }56/N237/APN237.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }56/N237/FAN237.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 055
        'numConvocatoria' : 'Convocatoria No. 055/2025.',
        'idConvocatoria' : 'Convocatoria55',
        'procedimientos' : [
            // Licitación N236
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N236-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Elaboración de estudios y proyecto para la construcción de la segunda planta de las oficinas administrativas de la Dirección General y obra externa complementaria del Colegio de Educación Profesional Técnica del Estado de Hidalgo, de Cobertura Estatal. (Segundo procedimiento)',
                'urlAnexos' : `${ ligabase }55/N236/N236.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }55/N236/JAN236.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }55/N236/APN236.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }55/N236/FAN236.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 054
        'numConvocatoria' : 'Convocatoria No. 054/2025.',
        'idConvocatoria' : 'Convocatoria54',
        'procedimientos' : [
            // Licitación N235
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N235-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Señalamiento vial para el Carril Confinado del Sistema de Transporte Masivo.; ubicado en varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }54/N235/N235.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }54/N235/JAN235.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }54/N235/APN235.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }54/N235/FAN235.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 053
        'numConvocatoria' : 'Convocatoria No. 053/2025.',
        'idConvocatoria' : 'Convocatoria53',
        'procedimientos' : [
            // Licitación N234
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N234-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025',
                'descripcionProcedimiento' : 'Reconstrucción de acceso a Villa de Tezontepec, en el municipio de Villa de Tezontepec.; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }53/N234/N234.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }53/N234/JAN234.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }53/N234/APN234.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }53/N234/FAN234.pdf`,
                       },
                ],
            },
            // Licitación N233
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N233-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Inmueble para Construcción del Centro Social y Cultural en el municipio de Progreso de Obregón.; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }53/N233/N233.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }53/N233/JAN233.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }53/N233/APN233.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }53/N233/FAN233.pdf`,
                    //    },
                ],
            },
            // Licitación N232
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N232-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Modernización del C.R. Tuzanapa - Cieneguillas, en el municipio de San Agustín Metzquititlán; ubicada en la localidad de Tuzanapa, Municipio de San Agustín Metzquititlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }53/N232/N232.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }53/N232/JAN232.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }53/N232/APN232.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }53/N232/FAN232.pdf`,
                       },
                ],
            },
            // Licitación N231
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N231-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de calle Vía de los Reyes, ubicada en la localidad de El Daxtha, municipio de Actopan.; ubicada en la localidad de El Daxtha, Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }53/N231/N231.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }53/N231/JAN231.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }53/N231/APN231.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }53/N231/FAN231.pdf`,
                       },
                ],
            },
            // Licitación N230
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N230-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico acceso a localidad de Acatepec, municipio de Lolotla .; ubicada en la localidad de Zihuatego (Ohuesco), Municipio de Lolotla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }53/N230/N230.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }53/N230/JAN230.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }53/N230/APN230.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }53/N230/FAN230.pdf`,
                       },
                ],
            },
            // Licitación N229
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N229-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de octubre al 7 de noviembre de 2025.',
                'descripcionProcedimiento' : 'Construcción del sistema de agua potable en las localidades de Palma Antigua el Vite, Cerro del Tezontle, San Sebastián, Palmillas, Aguacatitla, El Peral, El Contento, San Juan Hueyapan, Cerritos y La Palmilla, en el municipio de Huasca de Ocampo.; ubicada en la localidad y Municipio de Huasca de Ocampo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }53/N229/N229.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }53/N229/JAN229.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }53/N229/APN229.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }53/N229/FAN229.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 052
        'numConvocatoria' : 'Convocatoria No. 052/2025.',
        'idConvocatoria' : 'Convocatoria52',
        'procedimientos' : [
            // Licitación N228
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N228-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Programa de Campo Limpio 2025; de Cobertura Estatal (Segundo Procedimiento)',
                'urlAnexos' : `${ ligabase }52/N228/N228.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }52/N228/JAN228.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }52/N228/APN228.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }52/N228/FAN228.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 051
        'numConvocatoria' : 'Convocatoria No. 051/2025.',
        'idConvocatoria' : 'Convocatoria51',
        'procedimientos' : [
            // Licitación N227
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N227-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Urbanización del Nuevo Parque Industrial en la Reserva de las 311 Ha. En Cd. Sahagún (1a etapa).; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }51/N227/N227.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }51/N227/JAN227.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }51/N227/APN227.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }51/N227/FAN227.pdf`,
                       },
                ],
            },
            // Licitación N226
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N226-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Calle Sur 4 (Sección Eje Oriente - Poniente - Oriente 5); ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }51/N226/N226.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }51/N226/JAN226.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }51/N226/APN226.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }51/N226/FAN226.pdf`,
                       },
                ],
            },
            // Licitación N225
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N225-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Avenida Eje Oriente - Poniente (Sección Sur 6 - Lala); ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }51/N225/N225.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }51/N225/JAN225.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }51/N225/APN225.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }51/N225/FAN225.pdf`,
                       },
                ],
            },
            // Licitación N224
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N224-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de calle interna del Parque MPYMES Sahagún,1ª Etapa; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }51/N224/N224.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }51/N224/JAN224.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }51/N224/APN224.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }51/N224/FAN224.pdf`,
                       },
                ],
            },
            // Licitación N223
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N223-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción del libramiento Zona Industrial Sahagún 1a Etapa (pavimento de concreto hidráulico y señalamiento) municipio de Tepeapulco.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }51/N223/N223.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }51/N223/JAN223.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }51/N223/APN223.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }51/N223/FAN223.pdf`,
                       },
                ],
            },
        ],
    },
        {
        // CONVOCATORIA NUM# 050
        'numConvocatoria' : 'Convocatoria No. 050/2025.',
        'idConvocatoria' : 'Convocatoria50',
        'procedimientos' : [
            // Licitación N222
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N222-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en las calles San Alfonso y Jesús Lugo, en el municipio de  Zempoala.; ubicada en la localidad de Privadas Santa Matilde, Municipio de Zempoala, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }50/N222/N222.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N222/JAN222.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }50/N222/APN222.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }50/N222/FAN222.pdf`,
                       },
                ],
            },
            // Licitación N221
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N221-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Construcción del camino rural Pozuelos a El Palmar del km 10.4 al km 12.2 (TE), en el municipio de Santiago de Anaya.; ubicada en la localidad de El Palmar, Municipio de Santiago de Anaya, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }50/N221/N221.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N221/JAN221.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }50/N221/APN221.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }50/N221/FAN221.pdf`,
                       },
                ],
            },
            // Licitación N220
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N220-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Construcción de puente vehicular en el camino rural Cerro Chiquito a San José del Valle, en el municipio de Tenango de Doria.; ubicada en la localidad de Cerro Chiquito, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }50/N220/N220.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N220/JAN220.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }50/N220/APN220.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }50/N220/FAN220.pdf`,
                    //    },
                ],
            },
            // Licitación N219
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N219-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción asfáltica de circuito La Providencia, entre carretera Providencia - Pachuquilla y Av. San Ángel, Fraccionamiento La Providencia Siglo XXI, en el municipio de Mineral de la Reforma.; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }50/N219/N219.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N219/JAN219.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }50/N219/APN219.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }50/N219/FAN219.pdf`,
                       },
                ],
            },
            // Licitación N218
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N218-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación C.E. Huejutla a Chalahuiyapa a Los Otates (SE), en el municipio de Huejutla de Reyes.; ubicada en la localidad de Los Otates, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }50/N218/N218.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N218/JAN218.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }50/N218/APN218.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }50/N218/FAN218.pdf`,
                       },
                ],
            },
            // Licitación N217
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N217-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de línea de conducción de agua potable en la localidad de Santiago Ixtlahuaca, en el municipio de Tasquillo .; ubicada en la localidad de Santiago Ixtlahuaca, Municipio de Tasquillo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }50/N217/N217.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N217/JAN217.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }50/N217/APN217.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }50/N217/FAN217.pdf`,
                       },
                ],
            },
            // Licitación N216
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N216-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación de concreto asfáltico de la calle Los Villas, localidad de El Rosario, en el municipio de Francisco I. Madero.; ubicada en la localidad de El Rosario, Municipio de Francisco I. Madero, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }50/N216/N216.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }50/N216/JAN216.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }50/N216/APN216.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }50/N216/FAN216.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 049
        'numConvocatoria' : 'Convocatoria No. 049/2025.',
        'idConvocatoria' : 'Convocatoria49',
        'procedimientos' : [
            // Licitación N215
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N215-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Mejoramiento del Instituto de Formación Profesional; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo (Segundo procedimiento)',
                'urlAnexos' : `${ ligabase }49/N215/N215.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }49/N215/JAN215.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }49/N215/APN215.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }49/N215/FAN215.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 048
        'numConvocatoria' : 'Convocatoria No. 048/2025.',
        'idConvocatoria' : 'Convocatoria48',
        'procedimientos' : [
            // Licitación N214
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N214-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Equipamiento de oficinas centrales del complejo "Hidalgo Honesto"; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }48/N214/N214.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }48/N214/JAN214.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }48/N214/APN214.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }48/N214/FAN214.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 047
        'numConvocatoria' : 'Convocatoria No. 047/2025.',
        'idConvocatoria' : 'Convocatoria47',
        'procedimientos' : [
            // Licitación N213
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N213-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Mantenimiento del Centro Cultural del Ferrocarril.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }47/N213/N213.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }47/N213/JAN213.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }47/N213/APN213.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }47/N213/FAN213.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 046
        'numConvocatoria' : 'Convocatoria No. 046/2025.',
        'idConvocatoria' : 'Convocatoria46',
        'procedimientos' : [
            // Licitación N212
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N212-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de Imagen Exterior del Centro de Expresión Juvenil, Ubicado en el Municipio de Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }46/N212/N212.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }46/N212/JAN212.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }46/N212/APN212.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }46/N212/FAN212.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 045
        'numConvocatoria' : 'Convocatoria No. 045/2025.',
        'idConvocatoria' : 'Convocatoria45',
        'procedimientos' : [
            // Licitación N211
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N211-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Construcción de un modulo de 2 plantas.; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }45/N211/N211.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }45/N211/JAN211.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }45/N211/APN211.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }45/N211/FAN211.pdf`,
                       },
                ],
            },
            // Licitación N210
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N210-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Mejoramiento y ampliación del CERESO de Tulancingo de Bravo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }45/N210/N210.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }45/N210/JAN210.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }45/N210/APN210.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }45/N210/FAN210.pdf`,
                       },
                ],
            },
            // Licitación N209
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N209-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Ampliación del Centro Estatal de Evaluación y Control de Confianza; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }45/N209/N209.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }45/N209/JAN209.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }45/N209/APN209.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }45/N209/FAN209.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 044
        'numConvocatoria' : 'Convocatoria No. 044/2025.',
        'idConvocatoria' : 'Convocatoria44',
        'procedimientos' : [
            // Licitación N208
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N208-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025',
                'descripcionProcedimiento' : 'Remodelación de parque en comunidad indígena en la región de la Sierra Gorda, beneficiando a la localidad de El Barrio (Barrio del Carmen), municipio de Chapulhuacán; ubicada en la localidad de EL BARRIO (BARRIO DEL CARMEN), Municipio de Chapulhuacán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }44/N208/N208.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N208/JAN208.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N208/APN208.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N208/FAN208.pdf`,
                       },
                ],
            },
            // Licitación N207
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N207-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Construcción de la Casa de la Mujer Indígena en la región Otomí Tepehua 1era etapa, ubicada en el predio "La Zarzamora" localidad el Desdavi, municipio de Tenango de Doria.; ubicada en la localidad de El Desdavi, Municipio de Tenango de Doria, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }44/N207/N207.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N207/JAN207.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N207/APN207.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N207/FAN207.pdf`,
                       },
                ],
            },
            // Licitación N206
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N206-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de octubre de 2015 de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense en la Carretera Huautla - Las Pilas s/n, en la localidad de Huautla, municipio de Huautla; ubicada en la localidad y Municipio de Huautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }44/N206/N206.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N206/JAN206.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N206/APN206.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N206/FAN206.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 043
        'numConvocatoria' : 'Convocatoria No. 043/2025.',
        'idConvocatoria' : 'Convocatoria43',
        'procedimientos' : [
            // Licitación N205
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N205-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025',
                'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Felipe Ángeles, colonia Rojo Gómez, en el municipio de Tetepango; ubicada en la localidad y Municipio de Tetepango, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }43/N205/N205.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N205/JAN205.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N205/APN205.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N205/FAN205.pdf`,
                       },
                ],
            },
            // Licitación N204
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N204-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de la calle Intermunicipal Prolongación 16 de Septiembre en Zapotlán - Camino a san Isidro en Zempoala, E.C.F. México - Pachuca; ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }43/N204/N204.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N204/JAN204.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N204/APN204.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N204/FAN204.pdf`,
                       },
                ],
            },
            // Licitación N203
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N203-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción asfáltica en Boulevard Paseos de Chavarria y Avenida Real de Minas, en varias localidades, en el municipio de Mineral de la Reforma; ubicada en la localidad de Santa María de la Calera, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }43/N203/N203.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N203/JAN203.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N203/APN203.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N203/FAN203.pdf`,
                       },
                ],
            },
            // Licitación N202
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N202-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de pavimento asfáltico en el Acceso a Xochitlán de las Flores, Segunda Etapa, en el municipio de Tula de Allende; ubicada en la localidad de Xochitlán de las Flores, Municipio de Tula de Allende, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }43/N202/N202.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N202/JAN202.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N202/APN202.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N202/FAN202.pdf`,
                       },
                ],
            },
            // Licitación N201
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N201-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación C.E. Huejutla a Santa Cruz (Segunda Etapa), en el municipio de Huejutla de Reyes; ubicada en la localidad de Santa Cruz, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }43/N201/N201.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N201/JAN201.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N201/APN201.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N201/FAN201.pdf`,
                       },
                ],
            },
            // Licitación N200
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N200-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación del Boulevard Luis Donaldo Colosio, ambos cuerpos, en el municipio de Pachuca de Soto; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }43/N200/N200.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N200/JAN200.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N200/APN200.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N200/FAN200.pdf`,
                       },
                ],
            },
            // Licitación N199
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N199-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle hacia el panteón, barrio Santa Cruz, en la localidad de Malila, municipio de Molango de Escamilla; ubicada en la localidad de Malila, Municipio de Molango de Escamilla, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }43/N199/N199.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N199/JAN199.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N199/APN199.pdf`,
                       },
                    {
                        'resultado' : 'Anexo moificatorio',
                        'urlresultado' : `${ ligabase }43/N199/AMDAPN199.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N199/FAN199.pdf`,
                       },
                ],
            },
            // Licitación N198
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N198-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de pavimentación en calle Santa María Amajac - Huaxtho, en el municipio de San Salvador; ubicada en la localidad de Santa María Amajac, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }43/N198/N198.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N198/JAN198.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N198/APN198.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N198/FAN198.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 042
        'numConvocatoria' : 'Convocatoria No. 042/2025.',
        'idConvocatoria' : 'Convocatoria42',
        'procedimientos' : [
            // Licitación N197
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N197-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025',
                'descripcionProcedimiento' : 'Laboratorio de Nuevos Alimentos LANUA (Primera Etapa); ubicada en la localidad de San miguel Tornacuxtla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }42/N197/N197.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N197/JAN197.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N197/APN197.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N197/FAN197.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 041
        'numConvocatoria' : 'Convocatoria No. 041/2025.',
        'idConvocatoria' : 'Convocatoria41',
        'procedimientos' : [
            // Licitación N196
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N196-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025',
                'descripcionProcedimiento' : 'Mantenimiento del Centro Cultural Regional de Huichapan.; ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }41/N196/N196.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N196/JAN196.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N196/APN196.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N196/FAN196.pdf`,
                       },
                ],
            },
            // Licitación N195
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N195-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Casa General Felipe Ángeles.; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }41/N195/N195.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N195/JAN195.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N195/APN195.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N195/FAN195.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 040
        'numConvocatoria' : 'Convocatoria No. 040/2025.',
        'idConvocatoria' : 'Convocatoria40',
        'procedimientos' : [
            // Licitación N194
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N194-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de Mercados Municipales. (Pachuca).; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }40/N194/N194.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N194/JAN194.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N194/APN194.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N194/FAN194.pdf`,
                       },
                ],
            },
            // Licitación N193
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N193-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de Mercados Municipales. (Molango).; ubicada en la localidad y Municipio de Molango de Escamilla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }40/N193/N193.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N193/JAN193.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N193/APN193.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N193/FAN193.pdf`,
                       },
                ],
            },
            // Licitación N192
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N192-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de Mercados Municipales. (Zimapán).; ubicada en la localidad y Municipio de Zimapán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }40/N192/N192.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N192/JAN192.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N192/APN192.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N192/FAN192.pdf`,
                       },
                ],
            },
            // Licitación N191
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N191-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de Mercados Municipales. (Ixmiquilpan).; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }40/N191/N191.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N191/JAN191.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N191/APN191.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N191/FAN191.pdf`,
                       },
                ],
            },
            // Licitación N190
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N190-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de Mercados Municipales. (Emiliano Zapata).; ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }40/N190/N190.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N190/JAN190.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N190/APN190.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N190/FAN190.pdf`,
                       },
                ],
            },
            // Licitación N189
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N189-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de octubre de 2025.',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de Mercados Municipales (Almoloya).; ubicada en la localidad y Municipio de Almoloya, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }40/N189/N189.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N189/JAN189.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N189/APN189.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N189/FAN189.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 039
        'numConvocatoria' : 'Convocatoria No. 039/2025.',
        'idConvocatoria' : 'Convocatoria39',
        'procedimientos' : [
            // Licitación N188
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N188-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025',
                'descripcionProcedimiento' : 'Modernización del camino tramo Tianguitengo - Chinameca, en el municipio de Tianguistengo; ubicada en la localidad de EL OCOTAL, Municipio de Tianguistengo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }39/N188/N188.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N188/JAN188.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N188/APN188.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N188/FAN188.pdf`,
                       },
                ],
            },
            // Licitación N187
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N187-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Ajacuba - San Agustín Tlaxiaca, diversos tramos, en el municipio de Ajacuba; ubicada en Varias localidades del Municipio de Ajacuba, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }39/N187/N187.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N187/JAN187.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N187/APN187.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N187/FAN187.pdf`,
                       },
                ],
            },
            // Licitación N186
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N186-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción asfáltica de calle camino a La Calera, entre av. San Ángel y boulevard Paseos de Chavarría,  Fraccionamiento Paseos de Chavarría, en el municipio de Mineral de la Reforma.; ubicada en la localidad de Ex-Hacienda de Chavarría, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }39/N186/N186.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N186/JAN186.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N186/APN186.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N186/FAN186.pdf`,
                       },
                ],
            },
            // Licitación N185
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N185-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Revolución, Ulapa de Melchor Ocampo, en el municipio de Tetepango.; ubicada en la localidad de Ulapa de Melchor Ocampo, Municipio de Tetepango, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }39/N185/N185.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N185/JAN185.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N185/APN185.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N185/FAN185.pdf`,
                       },
                ],
            },
            // Licitación N184
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N184-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimento en el libramiento Tlahuelilpan, segunda etapa, en el municipio de Tlahuelilpan.; ubicada en la localidad y Municipio de Tlahuelilpan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }39/N184/N184.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N184/JAN184.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N184/APN184.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N184/FAN184.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }39/N184/FAN184.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 038
        'numConvocatoria' : 'Convocatoria No. 038/2025.',
        'idConvocatoria' : 'Convocatoria38',
        'procedimientos' : [
            // Licitación N183
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N183-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025',
                'descripcionProcedimiento' : 'Elaboración de estudios y proyecto para la construcción de la segunda planta de las oficinas administrativas de la Dirección General y obra externa complementaria del Colegio de Educación Profesional Técnica del Estado de Hidalgo, de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }38/N183/N183.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N183/JAN183.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N183/APN183.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }38/N183/FAN183.pdf`,
                    //    },
                ],
            },
            // Licitación N182
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N182-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Remodelación de espacio recreativo y deportivo Las Canchitas, en el municipio de Actopan.; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }38/N182/N182.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N182/JAN182.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N182/APN182.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N182/FAN182.pdf`,
                       },
                ],
            },
            // Licitación N181
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N181-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Alcalde, Fraccionamiento Colosio, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }38/N181/N181.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N181/JAN181.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N181/APN181.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N181/FAN181.pdf`,
                       },
                ],
            },
            // Licitación N180
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N180-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación en calle Antonio Tagle, en Col. Juan C. Doria, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }38/N180/N180.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N180/JAN180.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N180/APN180.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N180/FAN180.pdf`,
                       },
                ],
            },
            // Licitación N179
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N179-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Adrián Guerrero Díaz, tramo: avenida Río de las Avenidas a avenida Revolución, en la Colonia Periodistas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }38/N179/N179.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N179/JAN179.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N179/APN179.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N179/FAN179.pdf`,
                       },
                ],
            },
            // Licitación N178
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N178-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle principal en localidad El Guajolote, municipio de Epazoyucan.; ubicada en la localidad de El Salto, Municipio de Epazoyucan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }38/N178/N178.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N178/JAN178.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N178/APN178.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N178/FAN178.pdf`,
                       },
                ],
            },
            // Licitación N177
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N177-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de septiembre al 10 de octubre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de planta de tratamiento de aguas residuales en la comunidad de Plomosas, en el municipio de Jacala de Ledezma.; ubicada en Varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }38/N177/N177.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N177/JAN177.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N177/APN177.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N177/FAN177.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 037
        'numConvocatoria' : 'Convocatoria No. 037/2025.',
        'idConvocatoria' : 'Convocatoria37',
        'procedimientos' : [
            // Licitación N176
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N176-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025',
                'descripcionProcedimiento' : 'Demolición de Salón de Plenos del Congreso del Estado de Hidalgo, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }37/N176/N176.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N176/JAN176.pdf`,
                       },
                       {
                           'resultado' : 'Aclaraciones (2da.)',
                           'urlresultado' : `${ ligabase }37/N176/JAN176-2.pdf`,
                        },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N176/APN176.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N176/FAN176.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 036
        'numConvocatoria' : 'Convocatoria No. 036/2025.',
        'idConvocatoria' : 'Convocatoria36',
        'procedimientos' : [
            // Licitación N175
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N175-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025',
                'descripcionProcedimiento' : 'Construcción de Pavimentación Asfáltica en las calles Allende, Jesús Lorenzo, Alfonso Estrada, Guerrero, Nicolás Bravo y Sin Nombre, en la localidad de Tunititlán, municipio de Chilcuautla.; ubicada en la localidad de Tunititlán, Municipio de Chilcuautla, Estado de Hidalgo. (Segundo procedimiento) ',
                'urlAnexos' : `${ ligabase }36/N175/N175.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N175/JAN175.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N175/APN175.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N175/FAN175.pdf`,
                       },
                ],
            },
            // Licitación N174
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N174-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense en la localidad de Huejutla de Reyes, Municipio de Huejutla de Reyes.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N174/N174.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N174/JAN174.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N174/APN174.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N174/FAN174.pdf`,
                       },
                ],
            },
            // Licitación N173
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N173-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense en la localidad de Mecatlan, Municipio de Yahualica; ubicada en la localidad de Mecatlán, Municipio de Yahualica, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N173/N173.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N173/JAN173.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N173/APN173.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N173/FAN173.pdf`,
                       },
                ],
            },
            // Licitación N172
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N172-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción de Corredor Artesanal de la Huasteca Hidalguense en la localidad de San Pedro, municipio de Huazalingo; ubicada en la localidad de San Pedro, Municipio de Huazalingo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N172/N172.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N172/JAN172.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N172/APN172.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N172/FAN172.pdf`,
                       },
                ],
            },
            // Licitación N171
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N171-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense, en la carretera Tlanchinol - Tianguispicula, en la localidad de Hueyapa, Municipio de Tlanchinol; ubicada en la localidad de Hueyapa, Municipio de Tlanchinol, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N171/N171.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N171/JAN171.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N171/APN171.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N171/FAN171.pdf`,
                       },
                ],
            },
            // Licitación N170
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N170-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense en la localidad de Calnali, municipio de Calnali; ubicada en la localidad y Municipio de Calnali, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N170/N170.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N170/JAN170.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N170/APN170.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N170/FAN170.pdf`,
                       },
                ],
            },
            // Licitación N169
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N169-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense, en la Unidad Deportiva Luis Donaldo Colosio Murrieta, en la localidad de San Felipe Orizatlán, municipio de San Felipe Orizatlán; ubicada en la localidad y Municipio de San Felipe Orizatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N169/N169.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N169/JAN169.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N169/APN169.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N169/FAN169.pdf`,
                       },
                ],
            },
            // Licitación N168
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N168-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense, en la Plaza del Maíz, perteneciente al barrio de Pahuatitla, en el municipio de Jaltocán.; ubicada en la localidad y Municipio de Jaltocán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N168/N168.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N168/JAN168.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N168/APN168.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N168/FAN168.pdf`,
                       },
                ],
            },
            // Licitación N167
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N167-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Corredor Artesanal de la Huasteca Hidalguense en la localidad de Atlapexco, Municipio de Atlapexco; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N167/N167.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N167/JAN167.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N167/APN167.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N167/FAN167.pdf`,
                       },
                ],
            },
            // Licitación N166
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N166-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025.',
                'descripcionProcedimiento' : 'Remodelación de parque en comunidad indígena en la región de Valle del Mezquital, beneficiando a la localidad de Casa Blanca, municipio de San Salvador.; ubicada en la localidad de Casa Blanca, Municipio de San Salvador, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }36/N166/N166.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N166/JAN166.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N166/APN166.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N166/FAN166.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 035
        'numConvocatoria' : 'Convocatoria No. 035/2025.',
        'idConvocatoria' : 'Convocatoria35',
        'procedimientos' : [
            // Licitación N165
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N165-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de septiembre al 3 de octubre de 2025',
                'descripcionProcedimiento' : 'Impermeabilización del CCLEH; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }35/N165/N165.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N165/JAN165.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N165/APN165.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N165/FAN165.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 034
        'numConvocatoria' : 'Convocatoria No. 034/2025.',
        'idConvocatoria' : 'Convocatoria34',
        'procedimientos' : [
            // Licitación N164
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N164-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 29 de septiembre de 2025',
                'descripcionProcedimiento' : 'Mejoramiento del Instituto de Formación Profesional; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }34/N164/N164.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N164/JAN164.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N164/APN164.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }34/N164/FAN164.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 033
        'numConvocatoria' : 'Convocatoria No. 033/2025.',
        'idConvocatoria' : 'Convocatoria33',
        'procedimientos' : [
            // Licitación N163
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N163-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 29 de septiembre de 2025',
                'descripcionProcedimiento' : 'Programa de Campo Limpio 2025; de Cobertura Estatal',
                'urlAnexos' : `${ ligabase }33/N163/N163.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N163/JAN163.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N163/APN163.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N163/FAN163.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 032
        'numConvocatoria' : 'Convocatoria No. 032/2025.',
        'idConvocatoria' : 'Convocatoria32',
        'procedimientos' : [
            // Licitación N162
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N162-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 23 de septiembre de 2025',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. acceso a Nicolás Flores, segunda etapa, en la localidad Santa Cruz, en el municipio de Nicolás Flores.; ubicada en la localidad y Municipio de Nicolás Flores, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N162/N162.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N162/JAN162.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N162/APN162.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N162/FAN162.pdf`,
                       },
                ],
            },
            // Licitación N161
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N161-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 23 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación del camino Zundhó - Sifón - San Agustín, en el municipio de Alfajayucan.; ubicada en la localidad de Segunda Manzana Zundhó, Municipio de Alfajayucan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N161/N161.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N161/JAN161.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N161/APN161.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N161/FAN161.pdf`,
                       },
                ],
            },
            // Licitación N160
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N160-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 23 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de la carretera san Gabriel - Carrasco, en el municipio de Tezontepec de Aldama.; ubicada en la localidad de San Gabriel, Municipio de Tezontepec de Aldama, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N160/N160.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N160/JAN160.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N160/APN160.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N160/FAN160.pdf`,
                       },
                ],
            },
            // Licitación N159
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N159-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 23 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimentación en varias calles en San José Tepenene, Centro, en el municipio de El Arenal.; ubicada en la localidad de San José Tepenene, Municipio de El Arenal, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N159/N159.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N159/JAN159.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N159/APN159.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N159/FAN159.pdf`,
                       },
                ],
            },
            // Licitación N158
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N158-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 23 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica de Av. 16 de septiembre, localidad San Miguel Tornacuxtla, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad de San Miguel Tornacuxtla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N158/N158.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N158/JAN158.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N158/APN158.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N158/FAN158.pdf`,
                       },
                ],
            },
            // Licitación N157
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N157-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Chihuahua en la Col. Las Campanitas, en el municipio de Pachuca de soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N157/N157.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N157/JAN157.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N157/APN157.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N157/FAN157.pdf`,
                       },
                ],
            },
            // Licitación N156
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N156-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de obras complementarias para la carretera Rancho Viejo - Las Vigas, en el municipio de Almoloya.; ubicada en la localidad de Rancho Nuevo, Municipio de Almoloya, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }32/N156/N156.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N156/JAN156.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N156/APN156.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N156/FAN156.pdf`,
                       },
                ],
            },
            // Licitación N155
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N155-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle 1ro. de Villa y Gómez Farias en la Col. Centro, en el Municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }32/N155/N155.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N155/JAN155.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }32/N155/APN155.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }32/N155/FAN155.pdf`,
                    //    },
                ],
            },
            // Licitación N154
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N154-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Pino, en la Col. La Palma, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N154/N154.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N154/JAN154.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }32/N154/APN154.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }32/N154/FAN154.pdf`,
                    //    },
                ],
            },
            // Licitación N153
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N153-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Terminación de la C.E. Chimalpa - Cárdenas - San Juan Ixtilmaco y obras complementarias, en el municipio de Apan.; ubicada en la localidad de San Juan Ixtilmaco, Municipio de Apan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N153/N153.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N153/JAN153.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N153/APN153.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N153/FAN153.pdf`,
                       },
                ],
            },
            // Licitación N152
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N152-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico del boulevard Colonias - Santa Catarina, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N152/N152.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N152/JAN152.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N152/APN152.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N152/FAN152.pdf`,
                       },
                ],
            },
            // Licitación N151
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N151-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Modernización y ampliación del camino rural Huazalingo - Tlanchinol, segunda etapa, en la localidad de Olotla, en el municipio de Tlanchinol.; ubicada en la localidad de Olotla, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }32/N151/N151.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N151/JAN151.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N151/APN151.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N151/FAN151.pdf`,
                       },
                ],
            },
            // Licitación N150
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N150-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Modernización y ampliación de C.R. Temango - Jalpa, en el municipio de Tlanchinol.; ubicada en la localidad de Jalpa, Municipio de Tlanchinol, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N150/N150.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N150/JAN150.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N150/APN150.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N150/FAN150.pdf`,
                       },
                ],
            },
            // Licitación N149
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N149-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de camino Texcapa - Petlapixca, Primera Etapa, en el municipio de Tepehuacán de Guerrero; ubicada en la localidad de Texcapa, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N149/N149.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N149/JAN149.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N149/APN149.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N149/FAN149.pdf`,
                       },
                ],
            },
            // Licitación N148
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N148-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la C.E. paso por Tulancingo, tramo Col. Magisterio - San José, municipio de Tulancingo de Bravo.; ubicada en Varias localidades del Municipio de Tulancingo de Bravo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N148/N148.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N148/JAN148.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N148/APN148.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N148/FAN148.pdf`,
                       },
                ],
            },
            // Licitación N147
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N147-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Terminación de la construcción del dren pluvial San Antonio - Rio de las Avenidas, en los municipios de Pachuca de Soto y Mineral de la Reforma.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N147/N147.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N147/JAN147.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N147/APN147.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N147/FAN147.pdf`,
                       },
                ],
            },
            // Licitación N146
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N146-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de kiosco central en el jardín de Los Hombres Ilustres en Pachuca de Soto, Hidalgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }32/N146/N146.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N146/JAN146.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }32/N146/APN146.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }32/N146/FAN146.pdf`,
                    //    },
                ],
            },
            // Licitación N145
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N145-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Elaboración de proyectos de nivelación de tierras agrícolas para riego por gravedad utilizando vehículos aéreos no tripulados con tecnología lidar, en los distritos de riego 003 Tula, 100 Alfajayucan y 112 Ajacuba; de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }32/N145/N145.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N145/JAN145.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N145/APN145.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N145/FAN145.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 031
        'numConvocatoria' : 'Convocatoria No. 031/2025.',
        'idConvocatoria' : 'Convocatoria31',
        'procedimientos' : [
            // Licitación N144
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N144-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 22 de septiembre de 2025',
                'descripcionProcedimiento' : 'Estudios de infraestructura para el proyecto Expansión (Primera Etapa), ubicados en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }31/N144/N144.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N144/JAN144.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N144/APN144.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N144/FAN144.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 030
        'numConvocatoria' : 'Convocatoria No. 030/2025.',
        'idConvocatoria' : 'Convocatoria30',
        'procedimientos' : [
            // Licitación N143
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N143-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 18 de septiembre de 2025',
                'descripcionProcedimiento' : 'Centro Gastronómico de Santiago de Anaya Segunda Etapa; ubicada en la localidad y Municipio de Santiago de Anaya, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }30/N143/N143.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N143/JAN143.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N143/APN143.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N143/FAN143.pdf`,
                       },
                ],
            },
            // Licitación N142
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N142-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 18 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Centro Gastronómico y Turístico Zapotlán de Juárez Primera etapa.; ubicada en la localidad de San Pedro Huaquilpan, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }30/N142/N142.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N142/JAN142.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N142/APN142.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N142/FAN142.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 029
        'numConvocatoria' : 'Convocatoria No. 029/2025.',
        'idConvocatoria' : 'Convocatoria29',
        'procedimientos' : [
            // Licitación N141
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N141-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025',
                'descripcionProcedimiento' : 'Mantenimiento de edificios y construcción de barda perimetral del parque Científico y Tecnológico de Hidalgo CITNOVA; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }29/N141/N141.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N141/JAN141.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N141/APN141.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N141/FAN141.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 028
        'numConvocatoria' : 'Convocatoria No. 028/2025.',
        'idConvocatoria' : 'Convocatoria28',
        'procedimientos' : [
            // Licitación N140
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N140-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025',
                'descripcionProcedimiento' : 'Trabajos especializados de mejora en la Infraestructura de la Ciudad de las Mujeres.; ubicada en la localidad y Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }28/N140/N140.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N140/JAN140.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N140/APN140.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N140/FAN140.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 027
        'numConvocatoria' : 'Convocatoria No. 027/2025.',
        'idConvocatoria' : 'Convocatoria27',
        'procedimientos' : [
            // Licitación N139
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N139-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de espacio de atención temporal en Huejutla de Reyes; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N139/N139.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N139/JAN139.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N139/APN139.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N139/FAN139.pdf`,
                       },
                ],
            },
            // Licitación N138
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N138-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Zimapán; ubicada en la localidad y Municipio de Zimapán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N138/N138.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N138/JAN138.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N138/APN138.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N138/FAN138.pdf`,
                       },
                ],
            },
            // Licitación N137
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N137-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Zacualtipán de Ángeles; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N137/N137.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N137/JAN137.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N137/APN137.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N137/FAN137.pdf`,
                       },
                ],
            },
            // Licitación N136
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N136-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Tula; ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N136/N136.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N136/JAN136.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N136/APN136.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N136/FAN136.pdf`,
                       },
                ],
            },
            // Licitación N135
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N135-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 17 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Huichapan; ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N135/N135.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N135/JAN135.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N135/APN135.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N135/FAN135.pdf`,
                       },
                ],
            },
            // Licitación N134
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N134-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Atitalaquia; ubicada en la localidad y Municipio de Atitalaquia, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N134/N134.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N134/JAN134.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N134/APN134.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N134/FAN134.pdf`,
                       },
                ],
            },
            // Licitación N133
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N133-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Acaxochitlán; ubicada en la localidad y Municipio de Acaxochitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N133/N133.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N133/JAN133.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N133/APN133.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N133/FAN133.pdf`,
                       },
                ],
            },
            // Licitación N132
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N132-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Casa de Día de Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N132/N132.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N132/JAN132.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N132/APN132.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N132/FAN132.pdf`,
                       },
                ],
            },
            // Licitación N131
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N131-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Casa de Día de Tlaxcoapan; ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N131/N131.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N131/JAN131.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N131/APN131.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N131/FAN131.pdf`,
                       },
                ],
            },
            // Licitación N130
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N130-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Casa de Día de Almoloya; ubicada en la localidad y Municipio de Almoloya, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }27/N130/N130.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N130/JAN130.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N130/APN130.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N130/FAN130.pdf`,
                       },
                ],
            },
            // Licitación N129
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N129-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Centro Gerontológico Integral de Zapotlán de Juárez (primera etapa); ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }27/N129/N129.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N129/JAN129.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N129/APN129.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N129/FAN129.pdf`,
                       },
                ],
            },
            // Licitación N128
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N128-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 15 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción del Nuevo Centro Gerontológico Integral de Huejutla de Reyes (Segunda Etapa); ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }27/N128/N128.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N128/JAN128.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N128/APN128.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N128/FAN128.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 026
        'numConvocatoria' : 'Convocatoria No. 026/2025.',
        'idConvocatoria' : 'Convocatoria26',
        'procedimientos' : [
            // Licitación N127
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N127-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025',
                'descripcionProcedimiento' : 'Terminación de la reconstrucción de la avenida corredor industrial 2a. etapa en el parque industrial Sahagún, en el municipio de Tepeapulco.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo (Segundo procedimiento)',
                'urlAnexos' : `${ ligabase }26/N127/N127.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N127/JAN127.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N127/APN127.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N127/FAN127.pdf`,
                       },
                ],
            },
            // Licitación N126
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N126-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de dren pluvial Santa Julia, municipio de Pachuca de Soto (primera etapa).; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N126/N126.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N126/JAN126.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N126/APN126.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N126/FAN126.pdf`,
                       },
                ],
            },
            // Licitación N125
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N125-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica y drenaje pluvial en Av. Francisco I. Madero, en el municipio de   Tlaxcoapan.; ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N125/N125.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N125/JAN125.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N125/APN125.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N125/FAN125.pdf`,
                       },
                ],
            },
            // Licitación N124
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N124-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle 12 de diciembre, Santiago Tlapacoya, en el municipio de Pachuca de  Soto.; ubicada en la localidad de Santiago Tlapacoya, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N124/N124.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N124/JAN124.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N124/APN124.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N124/FAN124.pdf`,
                       },
                ],
            },
            // Licitación N123
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N123-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de banquetas, luminarias y bolardos, en la cabecera municipal de Mineral del Chico.; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos' : `${ ligabase }26/N123/N123.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N123/JAN123.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N123/APN123.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N123/FAN123.pdf`,
                       },
                ],
            },
            // Licitación N122
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N122-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico calle acceso a Rancho La Colonia, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N122/N122.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N122/JAN122.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N122/APN122.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N122/FAN122.pdf`,
                       },
                ],
            },
            // Licitación N121
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N121-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en las calles Zafiro, Venturina, Obsidiana, Granate, y Fresnos en la Colonia La Joya y la Colonia San Miguel Huatengo, en el municipio de Santiago Tulantepec; ubicada en la localidad de La Joya, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N121/N121.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N121/JAN121.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N121/APN121.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N121/FAN121.pdf`,
                       },
                ],
            },
            // Licitación N120
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N120-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto estampado en calle Morelos, Colonia Centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N120/N120.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N120/JAN120.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N120/APN120.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N120/FAN120.pdf`,
                       },
                ],
            },
            // Licitación N119
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N119-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico calle Vicente Guerrero, Independencia, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N119/N119.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N119/JAN119.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N119/APN119.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N119/FAN119.pdf`,
                       },
                ],
            },
            // Licitación N118
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N118-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en libramiento Teñhé - Morelos, en el municipio de Mixquiahuala de Juárez.; ubicada en la localidad de Colonia Teñhe, Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N118/N118.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N118/JAN118.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N118/APN118.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N118/FAN118.pdf`,
                       },
                ],
            },
            // Licitación N117
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N117-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Hidráulica calle de acceso a la colonia Altepemila, municipio de Santiago Tulantepec.; ubicada en la localidad de Altepemila, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N117/N117.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N117/JAN117.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N117/APN117.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N117/FAN117.pdf`,
                       },
                ],
            },
            // Licitación N116
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N116-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 de agosto al 1 de septiembre de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica del camino intermunicipal Cardonal - Tlahuiltepa, tramo El Moxthe - Cieneguilla, en el municipio de Cardonal.; ubicada en la localidad de Moxthe, Municipio de Cardonal, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N116/N116.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N116/JAN116.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N116/APN116.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N116/FAN116.pdf`,
                       },
                ],
            },
            // Licitación N115
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N115-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento asfáltico Alcholoya - San Bartolo, en el municipio de Acatlán.; ubicada en la localidad de Alcholoya (El Salto de Alcholoya), Municipio de Acatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N115/N115.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N115/JAN115.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N115/APN115.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N115/FAN115.pdf`,
                       },
                ],
            },
            // Licitación N114
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N114-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de circuito Vicente Aguirre del Castillo, Juan C. Doria, en el municipio de Pachuca de Soto .; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N114/N114.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N114/JAN114.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N114/APN114.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N114/FAN114.pdf`,
                       },
                ],
            },
            // Licitación N113
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N113-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de avenida Corona del Rosal, conjunto habitacional Juan C. Doria (segunda etapa), en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N113/N113.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N113/JAN113.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N113/APN113.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N113/FAN113.pdf`,
                       },
                ],
            },
            // Licitación N112
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N112-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle de Los Pinos, en la Col. San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N112/N112.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N112/JAN112.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N112/APN112.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N112/FAN112.pdf`,
                       },
                ],
            },
            // Licitación N111
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N111-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de Concreto Hidráulico en el Camino de acceso a Ixtlahuac, en el municipio de Huazalingo.; ubicada en la localidad de Ixtlahuac, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N111/N111.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N111/JAN111.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N111/APN111.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N111/FAN111.pdf`,
                       },
                ],
            },
            // Licitación N110
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N110-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de cancha de basquetbol y construcción de gradas en la comunidad de Mangas, en el municipio de Tezontepec de Aldama.; ubicada en la localidad de Mangas, Municipio de Tezontepec de Aldama, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N110/N110.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N110/JAN110.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N110/APN110.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N110/FAN110.pdf`,
                       },
                ],
            },
            // Licitación N109
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N109-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de plaza del centro histórico, en el municipio de Tecozautla.; ubicada en la localidad y Municipio de Tecozautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N109/N109.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N109/JAN109.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N109/APN109.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N109/FAN109.pdf`,
                       },
                ],
            },
            // Licitación N108
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N108-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación en calle Mirasoles (carretera México - Tuxpan a Mirasoles), en el municipio de Singuilucan.; ubicada en la localidad de Mirasoles, Municipio de Singuilucan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N108/N108.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N108/JAN108.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N108/APN108.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N108/FAN108.pdf`,
                       },
                ],
            },
            // Licitación N107
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N107-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la Carretera El Durazno a La Palma en el municipio de Ixmiquilpan.; ubicada en la localidad de El Durazno, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N107/N107.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N107/JAN107.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N107/APN107.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N107/FAN107.pdf`,
                       },
                ],
            },
            // Licitación N106
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N106-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Hidráulica Jardín de las Flores, en la localidad de Pueblo Nuevo, en el municipio de Ixmiquilpan.; ubicada en la localidad de Pueblo Nuevo, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N106/N106.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N106/JAN106.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N106/APN106.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }26/N106/FAN106.pdf`,
                    //    },
                ],
            },
            // Licitación N105
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N105-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en camino de acceso Coamilla - Buena Vista, en el municipio de Huejutla de Reyes.; ubicada en la localidad de Coamila, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N105/N105.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N105/JAN105.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }26/N105/APN105.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }26/N105/FAN105.pdf`,
                    //    },
                ],
            },
            // Licitación N104
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N104-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Modernización y ampliación del camino rural Xochicoatlán - Tianguistengo, en el municipio de Xochicoatlán.; ubicada en Varias localidades del Municipio de Xochicoatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N104/N104.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N104/JAN104.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N104/APN104.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N104/FAN104.pdf`,
                       },
                ],
            },
            // Licitación N103
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N103-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción del acceso principal a la cabecera (cuerpo derecho) entronque con Carretera Apan - Calpulalpan, en el municipio de Emiliano Zapata.; ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N103/N103.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N103/JAN103.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N103/APN103.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N103/FAN103.pdf`,
                       },
                ],
            },
            // Licitación N102
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N102-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle La Piaña, Santa María Amajac, Segunda Etapa, en el municipio de Atotonilco El Grande.; ubicada en la localidad de Santa María Amajac, Municipio de Atotonilco el Grande, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N102/N102.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N102/JAN102.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N102/APN102.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N102/FAN102.pdf`,
                       },
                ],
            },
            // Licitación N101
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N101-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción del sistema de agua potable para beneficiar a la localidad de Tepepa (Terminación), municipio de Acaxochitlán.; ubicada en la localidad de Tepepa (Santiago Tepepa), Municipio de Acaxochitlán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }26/N101/N101.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N101/JAN101.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N101/APN101.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N101/FAN101.pdf`,
                       },
                ],
            },
            // Licitación N100
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N100-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de dren pluvial en la comunidad de Pepeyocatitla, en el municipio de Yahualica.; ubicada en la localidad de Pepeyocatitla, Municipio de Yahualica, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N100/N100.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N100/JAN100.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N100/APN100.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N100/FAN100.pdf`,
                       },
                ],
            },
            // Licitación N99
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N99-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación del Sistema de Agua Potable de la localidad de La Reforma (segunda etapa), municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Almolo (San Isidro), Municipio de Tepehuacán de Guerrero, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N99/N99.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N99/JAN99.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N99/APN99.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N99/FAN99.pdf`,
                       },
                ],
            },
            // Licitación N98
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N98-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de Pavimentación Asfáltica en las calles Allende, Jesús Lorenzo, Alfonso Estrada, Guerrero, Nicolás Bravo y Sin Nombre, en la localidad de Tunititlán, municipio de Chilcuautla.; ubicada en la localidad de Tunititlán, Municipio de Chilcuautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N98/N98.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N98/JAN98.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N98/APN98.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N98/FAN98.pdf`,
                       },
                ],
            },
            // Licitación N97
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N97-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Mariano Arista, Colonia Centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N97/N97.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N97/JAN97.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N97/APN97.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N97/FAN97.pdf`,
                       },
                ],
            },
            // Licitación N96
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N96-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en la localidad de Morelos, en el municipio de Omitlán de Juárez.; ubicada en la localidad de Morelos, Municipio de Omitlán de Juárez, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N96/N96.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N96/JAN96.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N96/APN96.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N96/FAN96.pdf`,
                       },
                ],
            },
            // Licitación N95
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N95-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de agosto de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción y rehabilitación del Boulevard Javier Rojo Gómez, en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }26/N95/N95.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }26/N95/JAN95.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N95/APN95.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N95/FAN95.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 025
        'numConvocatoria' : 'Convocatoria No. 025/2025.',
        'idConvocatoria' : 'Convocatoria25',
        'procedimientos' : [
            // Licitación N94
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N94-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de agosto de 2025',
                'descripcionProcedimiento' : 'Restauración de la Estación de Ferrocarril "Animas"; ubicada en la localidad de Francisco Villa, Municipio de Zempoala, Estado de Hidalgo. (Segundo procedimiento)',
                'urlAnexos' : `${ ligabase }25/N94/N94.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }25/N94/JAN94.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N94/APN94.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }25/N94/FAN94.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 024
        'numConvocatoria' : 'Convocatoria No. 024/2025.',
        'idConvocatoria' : 'Convocatoria24',
        'procedimientos' : [
            // Licitación N93
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N93-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 11 al 22 de agosto de 2025',
                'descripcionProcedimiento' : 'Construcción de sanitarios con biodigestor para beneficiar a las localidades de Tutotepec (8) y El Nenjo (6) del municipio de San Bartolo Tutotepec; ubicada en varias localidades del Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }24/N93/N93.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N93/JAN93.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N93/APN93.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N93/FAN93.pdf`,
                       },
                ],
            },
            // Licitación N92
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N92-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 11 al 22 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de sanitarios con biodigestor para beneficiar a las localidades de San Pedro Tlachichilco (5), Santana Tzacuala (5) y Santiago Tepepa (5) del municipio de Acaxochitlán; ubicada en varias localidades del Municipio de Acaxochitlán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }24/N92/N92.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N92/JAN92.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N92/APN92.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N92/FAN92.pdf`,
                       },
                ],
            },
            // Licitación N91
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N91-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 11 al 22 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de sanitarios con biodigestor para beneficiar a las localidades de San Nicolas Cebolletas (6), Laguna del Cerrito (5) y San Vidal (5) del municipio de Tulancingo de Bravo; ubicada en varias localidades del Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }24/N91/N91.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }24/N91/JAN91.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }24/N91/APN91.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }24/N91/FAN91.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 023
        'numConvocatoria' : 'Convocatoria No. 023/2025.',
        'idConvocatoria' : 'Convocatoria23',
        'procedimientos' : [
            // Licitación N90
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N90-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025',
                'descripcionProcedimiento' : 'Construcción de línea de conducción de agua potable de Miahuatla a la cabecera municipal de Chapulhuacán, municipio de Chapulhuacán.; ubicada en la localidad y Municipio de Chapulhuacán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }23/N90/N90.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N90/JAN90.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N90/APN90.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N90/FAN90.pdf`,
                       },
                ],
            },
            // Licitación N89
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N89-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Asfáltica en Camino 2 de noviembre y camino Francisco Villa en la Comunidad de Texcatepec, municipio de Chilcuautla.; ubicada en la localidad de Texcatepec, Municipio de Chilcuautla, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }23/N89/N89.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N89/JAN89.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N89/APN89.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N89/FAN89.pdf`,
                       },
                ],
            },
            // Licitación N88
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N88-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de Pavimentación de Concreto Hidráulico en el Camino Rural Huilotitla I a Huilotitla II en el municipio de Huazalingo; ubicada en la localidad de Huilotitla I, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }23/N88/N88.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N88/JAN88.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N88/APN88.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N88/FAN88.pdf`,
                       },
                ],
            },
            // Licitación N87
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N87-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Hidráulica en varias calles de la localidad de El Mandho, en el municipio de Ixmiquilpan; ubicada en la localidad de El Mandho, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }23/N87/N87.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N87/JAN87.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N87/APN87.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N87/FAN87.pdf`,
                       },
                ],
            },
            // Licitación N86
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N86-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Terminación de la C.E. Chimalpa - Cárdenas - San Juan Ixtilmaco y obras completarías, en el municipio de Apan.; ubicada en la localidad de San Juan Ixtilmaco, Municipio de Apan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }23/N86/N86.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N86/JAN86.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N86/APN86.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N86/FAN86.pdf`,
                       },
                ],
            },
            // Licitación N85
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N85-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica del acceso principal de la localidad de Huizachez, en municipio de Tasquillo; ubicada en la localidad de Huizachez, Municipio de Tasquillo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }23/N85/N85.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N85/JAN85.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N85/APN85.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N85/FAN85.pdf`,
                       },
                ],
            },
            // Licitación N84
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N84-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación asfáltica en av. Ejército constitucionalista de la comunidad de Huaxtho, en el municipio de Actopan; ubicada en la localidad de El Huaxtho, Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }23/N84/N84.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N84/JAN84.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N84/APN84.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N84/FAN84.pdf`,
                       },
                ],
            },
            // Licitación N83
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N83-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica en Av. Epazoyucan, Xochihuacán, municipio de Epazoyucan; ubicada en la localidad de Xochihuacán (Fraccionamiento, Municipio de Epazoyucan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }23/N83/N83.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N83/JAN83.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N83/APN83.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N83/FAN83.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }23/N83/AMDFAN83.pdf`,
                       },
                ],
            },
            // Licitación N82
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N82-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Apertura de camino intermunicipal Tula (Calnai) - Tuzancocac (Xochicoatlán), en el municipio de Calnai; ubicada en la localidad de Xontla, Municipio de Calnai, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }23/N82/N82.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N82/JAN82.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N82/APN82.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N82/FAN82.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }23/N82/AMDFAN82.pdf`,
                       },
                ],
            },
            // Licitación N81
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N81-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de acceso a la comunidad de Ixtacuayo, en el municipio de Atlapexco; ubicada en la localidad de Ixtacuayo, Municipio de Atlapexco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }23/N81/N81.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N81/JAN81.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N81/APN81.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N81/FAN81.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }23/N81/AMDFAN81.pdf`,
                       },
                ],
            },
            // Licitación N80
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N80-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación del camino principal en la entrada a la comunidad de los Naranjos límite municipal Tianguistengo en el municipio de Yahualica; ubicada en la localidad de Los Naranjos, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }23/N80/N80.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N80/JAN80.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N80/APN80.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N80/FAN80.pdf`,
                       },
                       {
                            'resultado' : 'Anexo modificatorio',
                            'urlresultado' : `${ ligabase }23/N80/AMDFAN80.pdf`,
                       },
                ],
            },
            // Licitación N79
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N79-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica de acceso a la Col. El Xithi, primera sección, en el municipio de Tepetitlán; ubicada en la localidad de Xithi Primera Sección, Municipio de Tepetitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }23/N79/N79.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }23/N79/JAN79.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }23/N79/APN79.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }23/N79/FAN79.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }23/N79/FAN79.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 022
        'numConvocatoria' : 'Convocatoria No. 022/2025.',
        'idConvocatoria' : 'Convocatoria22',
        'procedimientos' : [
            // Licitación N78
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N78-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 30 de julio al 5 de agosto de 2025',
                'descripcionProcedimiento' : 'Supervisión, control y seguimiento de obra y verificación del control de calidad, realizada por terceros para el proyecto integral “Centro Administrativo y de Servicios para el Pueblo (CASP), en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }22/N78/N78.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }22/N78/JAN78.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }22/N78/APN78.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }22/N78/FAN78.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 021
        'numConvocatoria' : 'Convocatoria No. 021/2025.',
        'idConvocatoria' : 'Convocatoria21',
        'procedimientos' : [
            // Licitación N77
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N77-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de agosto de 2025',
                'descripcionProcedimiento' : 'Rehabilitación de áreas administrativas y de atención en palacio de Gobierno del Estado de Hidalgo, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }21/N77/N77.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }21/N77/JAN77.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }21/N77/APN77.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }21/N77/FAN77.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 020
        'numConvocatoria' : 'Convocatoria No. 020/2025.',
        'idConvocatoria' : 'Convocatoria20',
        'procedimientos' : [
            // Licitación N76
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N76-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de agosto de 2025',
                'descripcionProcedimiento' : 'Estudio para implementar un Proyecto Arquitectónico de Mercado tipo para el Estado de Hidalgo; Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }20/N76/N76.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }20/N76/JAN76.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }20/N76/APN76.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }20/N76/FAN76.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 019
        'numConvocatoria' : 'Convocatoria No. 019/2025.',
        'idConvocatoria' : 'Convocatoria19',
        'procedimientos' : [
            // Licitación N75
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N75-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de julio al 8 de agosto de 2025',
                'descripcionProcedimiento' : 'Habilitación de Celda de Disposición Final para el municipio de Jacala de Ledezma; ubicada en la localidad de Jacala, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }19/N75/N75.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }19/N75/JAN75.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }19/N75/APN75.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }19/N75/FAN75.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 018
        'numConvocatoria' : 'Convocatoria No. 018/2025.',
        'idConvocatoria' : 'Convocatoria18',
        'procedimientos' : [
            // Licitación N74
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N74-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de julio al 5 de agosto de 2025',
                'descripcionProcedimiento' : 'Rehabilitación general de módulos no. 2, no. 8, cancha de fútbol y plaza cívica, en el centro de expresión juvenil, ubicado en Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }18/N74/N74.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }18/N74/JAN74.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }18/N74/APN74.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }18/N74/FAN74.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 017
        'numConvocatoria' : 'Convocatoria No. 017/2025.',
        'idConvocatoria' : 'Convocatoria17',
        'procedimientos' : [
            // Licitación N73
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N73-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de julio al 5 de agosto de 2025',
                'descripcionProcedimiento' : 'Rehabilitación General de Centros Pilares, sedes Pachuca de Soto, Hgo., ubicada en varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }17/N73/N73.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }17/N73/JAN73.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }17/N73/APN73.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }17/N73/FAN73.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 016
        'numConvocatoria' : 'Convocatoria No. 016/2025.',
        'idConvocatoria' : 'Convocatoria16',
        'procedimientos' : [
            // Licitación N72
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N72-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 28 de julio al 5 de agosto de 2025',
                'descripcionProcedimiento' : 'Rehabilitación General del Albergue Revolución, ubicado en Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }16/N72/N72.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }16/N72/JAN72.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }16/N72/APN72.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }16/N72/FAN72.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 015
        'numConvocatoria' : 'Convocatoria No. 015/2025.',
        'idConvocatoria' : 'Convocatoria15',
        'procedimientos' : [
            // Licitación N71
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N71-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025',
                'descripcionProcedimiento' : 'Pavimentación asfáltica del camino El Carrizo - La Peña - Veladero - Agua Bendita, en el municipio de San Agustín  Metzquititlán.; ubicada en la localidad de Agua Bendita, Municipio de San Agustín Metzquititlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N71/N71.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N71/JAN71.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N71/APN71.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N71/FAN71.pdf`,
                       },
                ],
            },
            // Licitación N70
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N70-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica de calle Sin Nombre del km 1.85 al km 2.69 localidad Mesa del Huizache, municipio de La Misión.; ubicada en la localidad de Mesa del Huizache, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N70/N70.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N70/JAN70.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N70/APN70.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N70/FAN70.pdf`,
                       },
                ],
            },
            // Licitación N69
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N69-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle San Mateo, barrio Carboneras, segunda etapa, Mineral de la Reforma.; ubicada en la localidad de Carboneras, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N69/N69.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N69/JAN69.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N69/APN69.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N69/FAN69.pdf`,
                       },
                ],
            },
            // Licitación N68
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N68-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica en Libramiento Xitri - Rojo Gómez, en el municipio de Tetepango.; ubicada en la localidad y Municipio de Tetepango, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N68/N68.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N68/JAN68.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N68/APN68.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N68/FAN68.pdf`,
                       },
                ],
            },
            // Licitación N67
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N67-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en avenida Javier Rojo Gómez, tramo 5 de Mayo a 20 de Noviembre, Santa Julia, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N67/N67.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N67/JAN67.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N67/APN67.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N67/FAN67.pdf`,
                       },
                ],
            },
            // Licitación N66
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N66-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Hidráulica en calle Antonio Ávila, San Antonio, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N66/N66.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N66/JAN66.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N66/APN66.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N66/FAN66.pdf`,
                       },
                ],
            },
            // Licitación N65
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N65-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Antiguo Heroico Colegio Militar colonia San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N65/N65.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N65/JAN65.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N65/APN65.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N65/FAN65.pdf`,
                       },
                ],
            },
            // Licitación N64
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N64-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en la Av. Universidad: tramo Av. Francisco I. Madero - Viaducto Javier Rojo  Gómez, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N64/N64.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N64/JAN64.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N64/APN64.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N64/FAN64.pdf`,
                       },
                ],
            },
            // Licitación N63
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N63-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de línea de conducción para agua potable de la puerta a Jiliapan (terminación), comunidades Los Fresnos, Canoas y Jiliapan, municipio de Pacula.; ubicada en la localidad de Saucillo, Municipio de Pacula, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N63/N63.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N63/JAN63.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N63/APN63.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N63/FAN63.pdf`,
                       },
                ],
            },
            // Licitación N62
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N62-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la Carretera a Tlamamala, en el municipio de Huazalingo.; ubicada en la localidad de Tlamamala, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N62/N62.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N62/JAN62.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }15/N62/AMDJAN62.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N62/APN62.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N62/FAN62.pdf`,
                       },
                ],
            },
            // Licitación N61
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N61-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de banquetas, luminarias y bolardos, en la cabecera municipal de Mineral del Chico.; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N61/N61.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N61/JAN61.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N61/APN61.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }15/N61/FAN61.pdf`,
                    //    },
                ],
            },
            // Licitación N60
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N60-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Francisco Villa, municipio de Tizayuca.; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N60/N60.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N60/JAN60.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N60/APN60.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N60/FAN60.pdf`,
                       },
                ],
            },
            // Licitación N59
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N59-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción del dren pluvial de San Carlos a Av. Álamo, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N59/N59.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N59/JAN59.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N59/APN59.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N59/FAN59.pdf`,
                       },
                ],
            },
            // Licitación N58
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N58-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Sistema de agua potable "Río Zacatlamaya", para abastecer a la cabecera municipal de Zacualtipán de Ángeles, San  Bernardo, Rincón Grande, Papaxtla y Tehuitzila, Hidalgo.; ubicada en Varias localidades del Municipio de Zacualtipán de Ángeles, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N58/N58.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N58/JAN58.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N58/APN58.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N58/FAN58.pdf`,
                       },
                ],
            },
            // Licitación N57
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N57-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Terminación de la reconstrucción de la avenida corredor industrial 2a. etapa en el parque industrial Sahagún, en el municipio de Tepeapulco.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N57/N57.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N57/JAN57.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N57/APN57.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }15/N57/FAN57.pdf`,
                    //    },
                ],
            },
            // Licitación N56
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N56-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 4 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de Pavimentación Asfáltica en la C.E. Acopinalco - Apan (Primera Etapa), en el municipio de Apan.; ubicada en la localidad de Acopinalco, Municipio de Apan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N56/N56.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N56/JAN56.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N56/APN56.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N56/FAN56.pdf`,
                       },
                ],
            },
            // Licitación N55
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N55-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico calle Melchor Ocampo, colonia Centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N55/N55.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N55/JAN55.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N55/APN55.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N55/FAN55.pdf`,
                       },
                ],
            },
            // Licitación N54
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N54-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Ampliación y rehabilitación del tramo carretero Tlanalapa - Cd. Sahagún, acceso principal, (primera etapa) en el municipio de Tlanalapa.; ubicada en la localidad y Municipio de Tlanalapa, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N54/N54.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N54/JAN54.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N54/APN54.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N54/FAN54.pdf`,
                       },
                ],
            },
            // Licitación N53
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N53-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico acceso a Cuatzatzas, en el municipio de Jaltocán.; ubicada en la localidad de Cuatzatzas, Municipio de Jaltocán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N53/N53.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N53/JAN53.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N53/APN53.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N53/FAN53.pdf`,
                       },
                ],
            },
            // Licitación N52
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N52-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Lomas de los Mexicas, Ex Hacienda de Coscotitlan, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N52/N52.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N52/JAN52.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N52/APN52.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N52/FAN52.pdf`,
                       },
                ],
            },
            // Licitación N51
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N51-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle de acceso a la localidad de Tripuente, en el municipio de Pisaflores.; ubicada en la localidad de Tripuente, Municipio de Pisaflores, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N51/N51.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N51/JAN51.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N51/APN51.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N51/FAN51.pdf`,
                       },
                ],
            },
            // Licitación N50
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N50-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico calle Santiago Tapia, colonia Centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N50/N50.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N50/JAN50.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N50/APN50.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N50/FAN50.pdf`,
                       },
                ],
            },
            // Licitación N49
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N49-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en Santa Mónica - El Tablón, primera etapa, en el municipio de Metztitlán.; ubicada en la localidad de Santa Mónica Autempa, Municipio de Metztitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N49/N49.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N49/JAN49.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N49/APN49.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N49/FAN49.pdf`,
                       },
                ],
            },
            // Licitación N48
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N48-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle 24 de Octubre, San Antonio El Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N48/N48.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N48/JAN48.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N48/APN48.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N48/FAN48.pdf`,
                       },
                ],
            },
            // Licitación N47
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N47-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle 2, calle 3, calle 5 y calle 1 Fracc. Real de Medinas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N47/N47.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N47/JAN47.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N47/APN47.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N47/FAN47.pdf`,
                       },
                ],
            },
            // Licitación N46
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N46-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de la Carretera Intermunicipal de Zapotlán de Juárez a Tolcayuca, en el municipio de Zapotlán de Juárez.; ubicada en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N46/N46.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N46/JAN46.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N46/APN46.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N46/FAN46.pdf`,
                       },
                ],
            },
            // Licitación N45
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N45-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico de la Av. Pirules, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N45/N45.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N45/JAN45.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N45/APN45.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N45/FAN45.pdf`,
                       },
                ],
            },
            // Licitación N44
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N44-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de camino Tlaxcalilla - El Carmen, en el municipio de Huichapan.; ubicada en la localidad de Tlaxcalilla, Municipio de Huichapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N44/N44.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N44/JAN44.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N44/APN44.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N44/FAN44.pdf`,
                       },
                ],
            },
            // Licitación N43
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N43-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de Pavimentación Hidráulica de la C.E. Cuautepec - Tulancingo (Segunda Etapa), en el municipio de Cuautepec de Hinojosa.; ubicada en la localidad de La Esperanza, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N43/N43.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N43/JAN43.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N43/APN43.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N43/FAN43.pdf`,
                       },
                ],
            },
            // Licitación N42
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N42-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Modernización de Carretera Refugio - Texas, en el municipio de Atotonilco de Tula.; ubicada en Varias localidades del Municipio de Atotonilco de Tula, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N42/N42.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N42/JAN42.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N42/APN42.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N42/FAN42.pdf`,
                       },
                ],
            },
            // Licitación N41
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N41-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Modernización de carretera Tlaxcoapan - Apaxco (tramo El Tablón - Texas) con concreto hidráulico, municipio de Atitalaquia.; ubicada en la localidad y Municipio de Atitalaquia, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N41/N41.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N41/JAN41.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N41/APN41.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N41/FAN41.pdf`,
                       },
                ],
            },
            // Licitación N40
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N40-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación del Boulevard Felipe Ángeles (Dos Cuerpos), municipio de Pachuca de Soto (Segunda Etapa).; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N40/N40.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N40/JAN40.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N40/APN40.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N40/FAN40.pdf`,
                       },
                ],
            },
            // Licitación N39
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N39-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico del Boulevard Nuevo Hidalgo del Entronque con Boulevard Luis Donaldo Colosio a la Antigua Carretera La Paz, municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N39/N39.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N39/JAN39.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N39/APN39.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N39/FAN39.pdf`,
                       },
                ],
            },
            // Licitación N38
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N38-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Santa Catarina de la C.E. - E.C.F. (Pachuca - Tempoal) del Km 0+000 al Km 1+000, municipio del Huejutla de Reyes.; ubicada en la localidad de Santa Catarina, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N38/N38.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N38/JAN38.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N38/APN38.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N38/FAN38.pdf`,
                       },
                ],
            },
            // Licitación N37
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N37-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de cunetas del camino a la Mina El Carrizal, en la localidad de El Barrón en el municipio de Zimapán.; ubicada en la localidad de Zimapan, Municipio de Zimapán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N37/N37.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N37/JAN37.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N37/APN37.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N37/FAN37.pdf`,
                       },
                ],
            },
            // Licitación N36
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N36-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica del acceso al municipio de Tlahuiltepa, tramo Xilocuatitla-Los Pocitos,  municipio de Tlahuiltepa.; ubicada en la localidad de Xilocuatitla (El Puerto de Xilocuatitla), Municipio de Tlahuiltepa, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N36/N36.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N36/JAN36.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N36/APN36.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N36/FAN36.pdf`,
                       },
                ],
            },
            // Licitación N35
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N35-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en camino San Gregorio - San Ambrosio, en la localidad de San Ambrosio, en el  municipio de Huehuetla.; ubicada en la localidad de San Ambrocio, Municipio de Huehuetla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N35/N35.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N35/JAN35.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N35/APN35.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N35/FAN35.pdf`,
                       },
                ],
            },
            // Licitación N34
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N34-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Impulsor Sector Primario, en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N34/N34.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N34/JAN34.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N34/APN34.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N34/FAN34.pdf`,
                       },
                ],
            },
            // Licitación N33
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N33-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico de Tohuaco Primero a Tohuaco Amatzintla, en el municipio de Huautla.; ubicada en la localidad de Tohuaco I, Municipio de Huautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }15/N33/N33.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N33/JAN33.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N33/APN33.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N33/FAN33.pdf`,
                       },
                ],
            },
            // Licitación N32
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N32-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Modernización del camino Jacala - Quetzalapa en el municipio de Jacala (tercera etapa), municipio de Jacala de Ledezma.; ubicada en Varias localidades del Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N32/N32.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N32/JAN32.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }15/N32/AMDJAN32.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N32/APN32.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N32/FAN32.pdf`,
                       },
                ],
            },
            // Licitación N31
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N31-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimentación hidráulica en calle de acceso a la localidad de Santa María Temaxcalapa, en el municipio de Tenango de Doria.; ubicada en la localidad de Santa María Temaxcalapa, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N31/N31.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N31/JAN31.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }15/N31/AMDJAN31.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N31/APN31.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N31/FAN31.pdf`,
                       },
                ],
            },
            // Licitación N30
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N30-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Magisterio, colonia Piracantos, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N30/N30.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N30/JAN30.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N30/APN30.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N30/FAN30.pdf`,
                       },
                ],
            },
            // Licitación N29
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N29-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 de julio al 1 de agosto de 2025.',
                'descripcionProcedimiento' : 'Continuación de la pavimentación hidráulica de la calle Cuauhtémoc, en el municipio de Tolcayuca.; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }15/N29/N29.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }15/N29/JAN29.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }15/N29/APN29.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }15/N29/FAN29.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 014
        'numConvocatoria' : 'Convocatoria No. 014/2025.',
        'idConvocatoria' : 'Convocatoria14',
        'procedimientos' : [
            // Licitación N28
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N28-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 21 al 25 de julio de 2025',
                'descripcionProcedimiento' : 'Restauración de la Estación de Ferrocarril "Animas"; ubicada en la localidad de Francisco Villa, Municipio de Zempoala, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }14/N28/N28.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }14/N28/JAN28.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligabase }14/N28/APN28.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }14/N28/FAN28.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 013
        'numConvocatoria' : 'Convocatoria No. 013/2025.',
        'idConvocatoria' : 'Convocatoria13',
        'procedimientos' : [
            // Licitación N27
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N27-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Golondrinas - Alfajayucan - Chapantongo - Tepetitlán, municipio de Chapantongo; ubicada en la localidad y Municipio de Chapantongo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }13/N27/N27.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N27/JAN27.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N27/APN27.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N27/FAN27.pdf`,
                       },
                ],
            },
            // Licitación N26
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N26-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica de carretera González González a El Águila, municipio de Santiago de Anaya.; ubicada en la localidad de González González, Municipio de Santiago de Anaya, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N26/N26.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N26/JAN26.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N26/APN26.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N26/FAN26.pdf`,
                       },
                ],
            },
            // Licitación N25
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N25-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Pavimentación con Huellas de Concreto Hidráulico en Camino Viejo de Manzana centro 1, en la localidad de Maguey Blanco, municipio de Ixmiquilpan.; ubicada en la localidad de Maguey Blanco, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }13/N25/N25.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N25/JAN25.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N25/APN25.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N25/FAN25.pdf`,
                       },
                ],
            },
            // Licitación N24
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N24-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la carretera Cardonal a Cerro Colorado, municipio de Cardonal.; ubicada en la localidad y Municipio de Cardonal, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N24/N24.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N24/JAN24.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N24/APN24.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N24/FAN24.pdf`,
                       },
                ],
            },
            // Licitación N23
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N23-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Pavimentación Hidráulica de Camino Xilitla a Texopich (primera etapa), municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Xilitla, Municipio de Xochiatipan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N23/N23.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N23/JAN23.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N23/APN23.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N23/FAN23.pdf`,
                       },
                ],
            },
            // Licitación N22
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N22-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la carretera El Lindero a Honey en el municipio de Acaxochitlán.; ubicada en la localidad de El Lindero, Municipio de Acaxochitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N22/N22.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N22/JAN22.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N22/APN22.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N22/FAN22.pdf`,
                       },
                ],
            },
            // Licitación N21
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N21-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Construcción de las oficinas de la DGCCE, Centro Estatal de Maquinaria y Laboratorio SIPDUS, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad de , Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N21/N21.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N21/JAN21.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N21/APN21.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N21/FAN21.pdf`,
                       },
                ],
            },
            // Licitación N20
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N20-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 21 de julio de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica de la C.E. Saucillo - Nopala (tercera etapa), en el municipio de Nopala de Villagrán.; ubicada en la localidad y Municipio de Nopala de Villagrán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N20/N20.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N20/JAN20.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N20/APN20.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N20/FAN20.pdf`,
                       },
                ],
            },
            // Licitación N19
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N19-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de julio de 2025.',
                'descripcionProcedimiento' : 'Rehabilitación de la C.E. Acaxochitlán a Tlamimilolpa a la mesa a Cuautepec (primera etapa), en el municipio de Acaxochitlán.; ubicada en la localidad de Tlamimilolpa, Municipio de Acaxochitlán, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }13/N19/N19.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N19/JAN19.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N19/APN19.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N19/FAN19.pdf`,
                       },
                ],
            },
            // Licitación N18
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N18-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de julio de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico en calle prolongación av. Javier Rojo Gómez, San Cayetano, municipio de  Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N18/N18.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N18/JAN18.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N18/APN18.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N18/FAN18.pdf`,
                       },
                ],
            },
            // Licitación N17
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N17-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de julio de 2025.',
                'descripcionProcedimiento' : 'Reconstrucción de pavimento asfáltico calle parque Hidalgo, municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }13/N17/N17.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N17/JAN17.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N17/APN17.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N17/FAN17.pdf`,
                       },
                ],
            },
            // Licitación N16
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N16-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de julio de 2025.',
                'descripcionProcedimiento' : 'Estudio y proyecto para el diseño de los cortes en excavaciones de las obras de remodelación de la Plaza Independencia, en el municipio de Pachuca de Soto; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }13/N16/N16.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }13/N16/JAN16.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }13/N16/APN16.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }13/N16/FAN16.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 012
        'numConvocatoria' : 'Convocatoria No. 012/2025.',
        'idConvocatoria' : 'Convocatoria12',
        'procedimientos' : [
            // Licitación N15
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N15-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de julio de 2025',
                'descripcionProcedimiento' : 'Rehabilitación General de CDC Morelos, ubicado en Pachuca de Soto, Hgo; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }12/N15/N15.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }12/N15/JAN15.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }12/N15/APN15.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }12/N15/FAN15.pdf`,
                       },
                ],
            },
        ],
    },

    {
        // CONVOCATORIA NUM# 011
        'numConvocatoria' : 'Convocatoria No. 011/2025.',
        'idConvocatoria' : 'Convocatoria11',
        'procedimientos' : [
            // Licitación N14
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N14-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 14 al 18 de julio de 2025',
                'descripcionProcedimiento' : 'Rehabilitación general de espacios en el CRIRH, sede Tula de Allende, Hgo; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }11/N14/N14.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }11/N14/JAN14.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }11/N14/APN14.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }11/N14/FAN14.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 010
        'numConvocatoria' : 'Convocatoria No. 010/2025.',
        'idConvocatoria' : 'Convocatoria10',
        'procedimientos' : [
            // Licitación N13
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N13-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de julio de 2025',
                'descripcionProcedimiento' : 'Rehabilitación General de Albergue Hospital del Niño DIF, ubicado en Pachuca de Soto, Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }10/N13/N13.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }10/N13/JAN13.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }10/N13/APN13.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }10/N13/FAN13.pdf`,
                       },
                ],
            },
        ],
    },

    {
        // CONVOCATORIA NUM# 009
        'numConvocatoria' : 'Convocatoria No. 009/2025.',
        'idConvocatoria' : 'Convocatoria9',
        'procedimientos' : [
            // Licitación N12
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N12-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 7 al 11 de julio de 2025',
                'descripcionProcedimiento' : 'Construcción de nuevo almacén general de la Oficialía Mayor del Poder Ejecutivo del Estado de Hidalgo; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }9/N12/N12.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }9/N12/JAN12.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }9/N12/APN12.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }9/N12/FAN12.pdf`,
                       },
                ],
            },
        ],
    },

    {
        // CONVOCATORIA NUM# 008
        'numConvocatoria' : 'Convocatoria No. 008/2025.',
        'idConvocatoria' : 'Convocatoria8',
        'procedimientos' : [
            // Licitación N11
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N11-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 7 al 18 de julio de 2025',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Huasca de Ocampo - Tulancingo (segunda etapa), en el municipio de Huasca de Ocampo; ubicada en la localidad y Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }8/N11/N11.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }8/N11/JAN11.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }8/N11/APN11.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }8/N11/FAN11.pdf`,
                       },
                ],
            },
        ],
    },

    {
    // CONVOCATORIA NUM# 007
        'numConvocatoria' : 'Convocatoria No. 007/2025.',
        'idConvocatoria' : 'Convocatoria7',
        'procedimientos' : [
    // Licitación N10
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N10-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 9 al 20 de junio de 2025',
                'descripcionProcedimiento' : 'Arco de Bienvenida Real del Monte; ubicado en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }7/N10/N10.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }7/N10/JAN10.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }7/N10/APN10.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }7/N10/FAN10.pdf`,
                   },
                ],
            },
        ],
},
    {
    // CONVOCATORIA NUM# 006
        'numConvocatoria' : 'Convocatoria No. 006/2025.',
        'idConvocatoria' : 'Convocatoria6',
        'procedimientos' : [
    // Licitación N9
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N9-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 30 de mayo al 12 de junio de 2025',
                'descripcionProcedimiento' : 'Nuevo Centro Deportivo de Alto Rendimiento; de Cobertura Estatal.',
                'urlAnexos' : `${ ligabase }6/N9/N9.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }6/N9/JAN9.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }6/N9/APN9.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }6/N9/FAN9.pdf`,
                   },
                ],
            },
        ],
},
        {
    // CONVOCATORIA NUM# 005
        'numConvocatoria' : 'Convocatoria No. 005/2025.',
        'idConvocatoria' : 'Convocatoria5',
        'procedimientos' : [
    // Licitación N8
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N8-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 26 al 30 de mayo de 2025',
                'descripcionProcedimiento' : 'Infraestructura exterior del complejo Hidalgo Honesto; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }5/N8/N8.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }5/N8/JAN8.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }5/N8/APN8.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }5/N8/FAN8.pdf`,
                   },
                ],
            },
        ],
        },
    {
    // CONVOCATORIA NUM# 004
        'numConvocatoria' : 'Convocatoria No. 004/2025.',
        'idConvocatoria' : 'Convocatoria4',
        'procedimientos' : [
    // Licitación N7
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N7-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 26 de mayo al 6 de junio de 2025',
                'descripcionProcedimiento' : 'Mantenimiento Integral Aeropuerto Nacional de Pachuca: "Juan Guillermo Villasana” Segunda Etapa; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }4/N7/N7.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }4/N7/JAN7.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }4/N7/APN7.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }4/N7/FAN7.pdf`,
                   },
                ],
            },
        ],
},
    {
    // CONVOCATORIA NUM# 003
        'numConvocatoria' : 'Convocatoria No. 003/2025.',
        'idConvocatoria' : 'Convocatoria3',
        'procedimientos' : [
    // Licitación N6
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N6-2025.',
                'vigencia' : 'Vigencia de venta de bases: del 26 de mayo al 6 de junio de 2025',
                'descripcionProcedimiento' : 'Construcción de Andador Turístico la Escondida Villa de Tezontepec; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }3/N6/N6.rar`,
                'resultados' : [
                   {
                       'resultado' : 'Aclaraciones',
                       'urlresultado' : `${ ligabase }3/N6/JAN6.pdf`,
                   },
                   {
                       'resultado' : 'Apertura',
                       'urlresultado' : `${ ligabase }3/N6/APN6.pdf`,
                   },
                   {
                       'resultado' : 'Fallo',
                       'urlresultado' : `${ ligabase }3/N6/FAN6.pdf`,
                   },
                ],
            },
        ],
},
    {
        // CONVOCATORIA NUM# 002
            'numConvocatoria' : 'Convocatoria No. 002/2025.',
            'idConvocatoria' : 'Convocatoria2',
            'procedimientos' : [
        // Licitación N5
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N5-2025.',
                    'vigencia' : 'Vigencia de venta de bases: del 22 al 29 de abril de 2025',
                    'descripcionProcedimiento' : 'Proyecto Integral para la Construcción del Centro Administrativo y de Servicios para el pueblo (CASP), en el municipio de Pachuca de Soto, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N5/N5.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }2/N5/JAN5.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }2/N5/AMDJAN5.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }2/N5/APN5.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }2/N5/FAN5.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 001
            'numConvocatoria' : 'Convocatoria No. 001/2025.',
            'idConvocatoria' : 'Convocatoria1',
            'procedimientos' : [
        // Licitación N4
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N4-2025.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 25 de abril de 2025',
                    'descripcionProcedimiento' : 'Reconstrucción del Boulevard Las Torres Cuerpo Izquierdo a base de concreto hidráulico, tramo del km 0+000 al km 6+490; ubicada en varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N4/N4.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N4/JAN4.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N4/APN4.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N4/FAN4.pdf`,
                       },
                    ],
                },
        // Licitación N3
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N3-2025.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 25 de abril de 2025.',
                    'descripcionProcedimiento' : 'Cercado perimetral de la granja interactiva granjaaventura; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N3/N3.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N3/JAN3.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N3/APN3.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N3/FAN3.pdf`,
                       },
                    ],
                },
        // Licitación N2
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N2-2025.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 25 de abril de 2025.',
                    'descripcionProcedimiento' : 'Rehabilitación de Imagen en Andadores Turísticos del Centro Histórico (Mineral Del Chico); ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N2/N2.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N2/JAN2.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N2/APN2.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N2/FAN2.pdf`,
                       },
                    ],
                },
        // Licitación N1
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N1-2025.',
                    'vigencia' : 'Vigencia de venta de bases: del 14 al 25 de abril de 2025.',
                    'descripcionProcedimiento' : 'Construcción de Andadores Turísticos en el Centro Histórico de Calnali; ubicada en la localidad y Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                       },
                    ],
                },
            ],
    }, 
]